var jquery = require("jquery");
window.$ = window.jQuery = jquery;
import LazyLoad from "lazyload";

/*shorten*/
!(function (s) {
  s.fn.shorten = function (e) {
    var t = {
      showChars: 100,
      ellipsesText: "...",
      moreText: "more",
      lessText: "less",
    };
    return (
      e && s.extend(t, e),
      s(document).off("click", ".morelink"),
      s(document).on(
        {
          click: function () {
            var e = s(this);
            return (
              e.hasClass("less")
                ? (e.removeClass("less"), e.html(t.moreText))
                : (e.addClass("less"), e.html(t.lessText)),
              e.parent().prev().toggle(),
              e.prev().toggle(),
              !1
            );
          },
        },
        ".morelink"
      ),
      this.each(function () {
        var e = s(this);
        if (!e.hasClass("shortened")) {
          e.addClass("shortened");
          var n = e.html();
          if (n.length > t.showChars) {
            var r = n.substr(0, t.showChars),
              a = n.substr(t.showChars, n.length - t.showChars),
              l =
                r +
                '<span class="moreellipses">' +
                t.ellipsesText +
                ' </span><span class="morecontent"><span>' +
                a +
                '</span> <a href="#" class="morelink">' +
                t.moreText +
                "</a></span>";
            e.html(l), s(".morecontent span").hide();
          }
        }
      })
    );
  };
})(jQuery);

$(document).ready(function () {
  let images = document.querySelectorAll(".lazyload");
  new LazyLoad(images);

  $(".fire-lazyload").on("custom", function (e) {
    let images1 = document.querySelectorAll(".lazyload");
    new LazyLoad(images1);
  });
});

$(document).ready(function () {
  let COUNTRY_MAP = {
    Denmark: {
      language_code: "da",
      country_code: "DK",
      currency: "DKK",
    },
    Germany: {
      language_code: "de",
      country_code: "DE",
      currency: "EUR",
    },
    Norway: {
      language_code: "nb",
      country_code: "NO",
      currency: "NOK",
    },
    "United Kingdom": {
      language_code: "en",
      country_code: "GB",
      currency: "GBP",
    },
    EU: {
      language_code: "en",
      country_code: "DE",
      currency: "EUR",
    },
    Sweden: {
      language_code: "sv",
      country_code: "SE",
      currency: "SEK",
    },
    Netherlands: {
      language_code: "nl",
      country_code: "NL",
      currency: "EUR",
    },
    France: {
      language_code: "fr",
      country_code: "FR",
      currency: "EUR",
    },
    Poland: {
      language_code: "pl",
      country_code: "PL",
      currency: "EUR",
    },
  };

  $("#close-country-notification").on("click", function () {
    window.localStorage.setItem("country_chosen", "true");
    $("#country-notification").hide();
  });

  const country_chosen = window.localStorage.getItem("country_chosen");
  let locale = $("body").data("shop-locale");

  if (!country_chosen && locale === "da") {
    $.get(
      "https://api.ipgeolocation.io/ipgeo?apiKey=e44060d980ae4b71aafa49b477cbd128",
      function (data) {
        let user_country = data.country_name;

        let pathname = window.location.pathname;

        console.log("country", user_country);

        //window.localStorage.setItem("country_chosen", "true");

        if (user_country !== "Denmark") {
          let country_info = COUNTRY_MAP[user_country]
            ? COUNTRY_MAP[user_country]
            : COUNTRY_MAP["EU"];

          $("#user-country").text(user_country);
          // $("#change-country-link").html(
          //   `<a href="/${country_info.country_code.toLowerCase()}${pathname}?currency=${
          //     country_info.currency
          //   }" style="color:#fff;text-decoration:underline" class="change-country" data-country-code="${
          //     country_info.country_code
          //   }">Change to ${country_info.currency}</a>`
          // );

          let href = `/${country_info.language_code}${pathname}`;
          console.log("🚀 ~ href", href);

          $("#change-country-link a").html(
            `Change to ${country_info.currency}`
          );
          $("#change-country-link a").attr("href", href);
          $("#change-country-link a").data(
            "country-code",
            country_info.country_code
          );

          $("#country-notification").show();

          //window.location.href = `/${country_info.country_code}${pathname}?currency=${country_info.currency}`;

          //   let country_info = COUNTRY_MAP[user_country];
          //   let language_short_code = country_info ? country_info.country_code : "en";
          //   let currency = country_info ? country_info.currency : "EUR";
          //   $("#location-bar").html(locale + 'It looks like you are not from Denmark. Switch to <a href="/' + language_short_code + "?currency=" + currency + '">Country name</a>');
          //   $("#location-bar").show();
        } else {
          window.localStorage.setItem("country_chosen", "true");
        }
      }
    );
  }
});

/*Bootstrap v3.3.7 (http://getbootstrap.com)*/
if ("undefined" == typeof jQuery)
  throw new Error("Bootstrap's JavaScript requires jQuery");
+(function (t) {
  "use strict";
  var e = t.fn.jquery.split(" ")[0].split(".");
  if (
    (e[0] < 2 && e[1] < 9) ||
    (1 == e[0] && 9 == e[1] && e[2] < 1) ||
    e[0] > 3
  )
    throw new Error(
      "Bootstrap's JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4"
    );
})(jQuery),
  +(function (t) {
    "use strict";
    function e(e, i) {
      return this.each(function () {
        var s = t(this),
          n = s.data("bs.modal"),
          r = t.extend({}, o.DEFAULTS, s.data(), "object" == typeof e && e);
        n || s.data("bs.modal", (n = new o(this, r))),
          "string" == typeof e ? n[e](i) : r.show && n.show(i);
      });
    }
    var o = function (e, o) {
      (this.options = o),
        (this.$body = t(document.body)),
        (this.$element = t(e)),
        (this.$dialog = this.$element.find(".modal-dialog")),
        (this.$backdrop = null),
        (this.isShown = null),
        (this.originalBodyPad = null),
        (this.scrollbarWidth = 0),
        (this.ignoreBackdropClick = !1),
        this.options.remote &&
          this.$element.find(".modal-content").load(
            this.options.remote,
            t.proxy(function () {
              this.$element.trigger("loaded.bs.modal");
            }, this)
          );
    };
    (o.VERSION = "3.3.7"),
      (o.TRANSITION_DURATION = 300),
      (o.BACKDROP_TRANSITION_DURATION = 150),
      (o.DEFAULTS = { backdrop: !0, keyboard: !0, show: !0 }),
      (o.prototype.toggle = function (t) {
        return this.isShown ? this.hide() : this.show(t);
      }),
      (o.prototype.show = function (e) {
        var i = this,
          s = t.Event("show.bs.modal", { relatedTarget: e });
        this.$element.trigger(s),
          this.isShown ||
            s.isDefaultPrevented() ||
            ((this.isShown = !0),
            this.checkScrollbar(),
            this.setScrollbar(),
            this.$body.addClass("modal-open"),
            this.escape(),
            this.resize(),
            this.$element.on(
              "click.dismiss.bs.modal",
              '[data-dismiss="modal"]',
              t.proxy(this.hide, this)
            ),
            this.$dialog.on("mousedown.dismiss.bs.modal", function () {
              i.$element.one("mouseup.dismiss.bs.modal", function (e) {
                t(e.target).is(i.$element) && (i.ignoreBackdropClick = !0);
              });
            }),
            this.backdrop(function () {
              var s = t.support.transition && i.$element.hasClass("fade");
              i.$element.parent().length || i.$element.appendTo(i.$body),
                i.$element.show().scrollTop(0),
                i.adjustDialog(),
                s && i.$element[0].offsetWidth,
                i.$element.addClass("in"),
                i.enforceFocus();
              var n = t.Event("shown.bs.modal", { relatedTarget: e });
              s
                ? i.$dialog
                    .one("bsTransitionEnd", function () {
                      i.$element.trigger("focus").trigger(n);
                    })
                    .emulateTransitionEnd(o.TRANSITION_DURATION)
                : i.$element.trigger("focus").trigger(n);
            }));
      }),
      (o.prototype.hide = function (e) {
        e && e.preventDefault(),
          (e = t.Event("hide.bs.modal")),
          this.$element.trigger(e),
          this.isShown &&
            !e.isDefaultPrevented() &&
            ((this.isShown = !1),
            this.escape(),
            this.resize(),
            t(document).off("focusin.bs.modal"),
            this.$element
              .removeClass("in")
              .off("click.dismiss.bs.modal")
              .off("mouseup.dismiss.bs.modal"),
            this.$dialog.off("mousedown.dismiss.bs.modal"),
            t.support.transition && this.$element.hasClass("fade")
              ? this.$element
                  .one("bsTransitionEnd", t.proxy(this.hideModal, this))
                  .emulateTransitionEnd(o.TRANSITION_DURATION)
              : this.hideModal());
      }),
      (o.prototype.enforceFocus = function () {
        t(document)
          .off("focusin.bs.modal")
          .on(
            "focusin.bs.modal",
            t.proxy(function (t) {
              document === t.target ||
                this.$element[0] === t.target ||
                this.$element.has(t.target).length ||
                this.$element.trigger("focus");
            }, this)
          );
      }),
      (o.prototype.escape = function () {
        this.isShown && this.options.keyboard
          ? this.$element.on(
              "keydown.dismiss.bs.modal",
              t.proxy(function (t) {
                27 == t.which && this.hide();
              }, this)
            )
          : this.isShown || this.$element.off("keydown.dismiss.bs.modal");
      }),
      (o.prototype.resize = function () {
        this.isShown
          ? t(window).on("resize.bs.modal", t.proxy(this.handleUpdate, this))
          : t(window).off("resize.bs.modal");
      }),
      (o.prototype.hideModal = function () {
        var t = this;
        this.$element.hide(),
          this.backdrop(function () {
            t.$body.removeClass("modal-open"),
              t.resetAdjustments(),
              t.resetScrollbar(),
              t.$element.trigger("hidden.bs.modal");
          });
      }),
      (o.prototype.removeBackdrop = function () {
        this.$backdrop && this.$backdrop.remove(), (this.$backdrop = null);
      }),
      (o.prototype.backdrop = function (e) {
        var i = this,
          s = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
          var n = t.support.transition && s;
          if (
            ((this.$backdrop = t(document.createElement("div"))
              .addClass("modal-backdrop " + s)
              .appendTo(this.$body)),
            this.$element.on(
              "click.dismiss.bs.modal",
              t.proxy(function (t) {
                return this.ignoreBackdropClick
                  ? void (this.ignoreBackdropClick = !1)
                  : void (
                      t.target === t.currentTarget &&
                      ("static" == this.options.backdrop
                        ? this.$element[0].focus()
                        : this.hide())
                    );
              }, this)
            ),
            n && this.$backdrop[0].offsetWidth,
            this.$backdrop.addClass("in"),
            !e)
          )
            return;
          n
            ? this.$backdrop
                .one("bsTransitionEnd", e)
                .emulateTransitionEnd(o.BACKDROP_TRANSITION_DURATION)
            : e();
        } else if (!this.isShown && this.$backdrop) {
          this.$backdrop.removeClass("in");
          var r = function () {
            i.removeBackdrop(), e && e();
          };
          t.support.transition && this.$element.hasClass("fade")
            ? this.$backdrop
                .one("bsTransitionEnd", r)
                .emulateTransitionEnd(o.BACKDROP_TRANSITION_DURATION)
            : r();
        } else e && e();
      }),
      (o.prototype.handleUpdate = function () {
        this.adjustDialog();
      }),
      (o.prototype.adjustDialog = function () {
        var t =
          this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
          paddingLeft: !this.bodyIsOverflowing && t ? this.scrollbarWidth : "",
          paddingRight: this.bodyIsOverflowing && !t ? this.scrollbarWidth : "",
        });
      }),
      (o.prototype.resetAdjustments = function () {
        this.$element.css({ paddingLeft: "", paddingRight: "" });
      }),
      (o.prototype.checkScrollbar = function () {
        var t = window.innerWidth;
        if (!t) {
          var e = document.documentElement.getBoundingClientRect();
          t = e.right - Math.abs(e.left);
        }
        (this.bodyIsOverflowing = document.body.clientWidth < t),
          (this.scrollbarWidth = this.measureScrollbar());
      }),
      (o.prototype.setScrollbar = function () {
        var t = parseInt(this.$body.css("padding-right") || 0, 10);
        (this.originalBodyPad = document.body.style.paddingRight || ""),
          this.bodyIsOverflowing &&
            this.$body.css("padding-right", t + this.scrollbarWidth);
      }),
      (o.prototype.resetScrollbar = function () {
        this.$body.css("padding-right", this.originalBodyPad);
      }),
      (o.prototype.measureScrollbar = function () {
        var t = document.createElement("div");
        (t.className = "modal-scrollbar-measure"), this.$body.append(t);
        var e = t.offsetWidth - t.clientWidth;
        return this.$body[0].removeChild(t), e;
      });
    var i = t.fn.modal;
    (t.fn.modal = e),
      (t.fn.modal.Constructor = o),
      (t.fn.modal.noConflict = function () {
        return (t.fn.modal = i), this;
      }),
      t(document).on(
        "click.bs.modal.data-api",
        '[data-toggle="modal"]',
        function (o) {
          var i = t(this),
            s = i.attr("href"),
            n = t(
              i.attr("data-target") || (s && s.replace(/.*(?=#[^\s]+$)/, ""))
            ),
            r = n.data("bs.modal")
              ? "toggle"
              : t.extend({ remote: !/#/.test(s) && s }, n.data(), i.data());
          i.is("a") && o.preventDefault(),
            n.one("show.bs.modal", function (t) {
              t.isDefaultPrevented() ||
                n.one("hidden.bs.modal", function () {
                  i.is(":visible") && i.trigger("focus");
                });
            }),
            e.call(n, r, this);
        }
      );
  })(jQuery);

(function ($) {
  $.getScriptCached = function (url, callback) {
    return $.ajax({ url: url, dataType: "script", cache: true }).done(callback);
  };
})(jQuery);

ajaxifyCart = (function ($) {
  var _config = {
    cartCountSelector: ".cart",
    cartTotalSelector: ".menu-right-amount",
    shopifyAjaxAddURL: "/cart/add.js",
    shopifyAjaxCartURL: "/cart.js",
  };

  var _init = function () {
    $(document).ready(function () {
      $("body").on("submit", 'form[action="/cart/add"]', function (e) {
        $(".product-active #product-submit").append(
          ' <i class="fa fa-circle-o-notch fa-spin" style="font-size: 20px;vertical-align: sub;"></i>'
        );
        e.preventDefault();
        var addToCartForm = $(this);

        var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
          navigator.userAgent
        )
          ? true
          : false;

        // Add to cart.
        $.ajax({
          url: _config.shopifyAjaxAddURL,
          dataType: "json",
          type: "post",
          data: addToCartForm.serialize(),
          success: function (itemData) {
            // Update cart count and show cart link.
            $.getJSON(_config.shopifyAjaxCartURL, function (cart) {
              var product_id = itemData.product_id;
              var variant_id = itemData.variant_id;
              var user_identifier = localStorage.getItem("user_identifier");

              // fbq("track", "AddToCart", {
              //   content_ids: [product_id],
              //   content_type: "product",
              // });

              /* Conversion Tracking Start */

              var google_conversion_id = $("body").data("google-conversion-id");
              var google_conversion_label = $("body").data(
                "google-conversion-label"
              );

              //var google_conversion_id = 984422849;
              var google_conversion_language = "en";
              var google_conversion_format = "3";
              var google_conversion_color = "ffffff";
              //var google_conversion_label = "S9UsCLHwgmwQwbO01QM";
              var google_remarketing_only = false;

              $.getScript("//www.googleadservices.com/pagead/conversion.js");

              var image = new Image(1, 1);
              image.src =
                "//www.googleadservices.com/pagead/conversion/" +
                google_conversion_id +
                "/?label=" +
                google_conversion_label +
                "&guid=ON&script=0";
              /* Conversion Tracking End */

              var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
                navigator.userAgent
              )
                ? true
                : false;

              $(".product-active .purchase-section .fa-spin").hide();

              $(".product-active #product-submit").append(
                ' <i class="fa fa-check" style="font-size: 20px;vertical-align: sub;"></i>'
              );

              var product_type = $("#product").data("type");
              var value = $("#cart_count_top").html() || "0";

              user_action_track("add_to_cart", product_id, variant_id);

              var checkDown = parseInt($(".navbar-cart-count").text(), 10);

              $(".cart-count").html(checkDown + 1);

              $(".cart-count").show();
              recombeeClient.send(
                new recombee.AddCartAddition(user_identifier, product_id)
              );

              if (1 == 1) {
                console.log("show cart");
                $("#cart_count_top").html(
                  value.replace(/[0-9]+/, cart.item_count)
                );
                $(".cart_count").show();
                $("#dropdown-cart").load("/cart #dropdown-cart .container");

                //disable zoom for a while
                $("head").append(
                  '<meta name="viewport" content="width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">'
                );
                $("#modal-product-added-to-cart").modal("show");
                let locale = $("body").data("shop-locale");
                let cartUrl =
                  locale === "da" ? "/cart" : "/" + locale + "/cart";
                $(
                  "#modal-product-added-to-cart .modal-body-content #modal-body-content-cart"
                ).load(cartUrl + " .cart-items > div", function () {
                  $(".cart-other-also-bought").show();
                  $("#recommendations-popup").html(
                    '<div class="recommended-products cart-recommended-products scrolling-wrapper" data-id="' +
                      product_id +
                      '" data-type="power_step" data-scenario="power_step" data-count="4" data-id="" data-container="cart-recommended-products" data-limit="7" data-row-width="3" data-class="lazyload"></div></div>'
                  );
                  recommendation_get();
                  $("#cart_user_identifier").val(
                    localStorage.getItem("user_identifier")
                  );
                });

                //make the right links

                if (!$("body").hasClass("product-opened")) {
                  $(".product-close").hide();
                  var category_title = $("#product").data("category");
                  var category_handle = $("#product").data("category-handle");
                  if (category_title) {
                    $(".product-continue-go-to-category").html(
                      "se mere fra " + category_title
                    );
                    $(".product-continue-go-to-category").attr(
                      "href",
                      "/collections/" + category_handle
                    );
                  }
                }
              } else {
                var title = $(".product-active h1").text();
                var product_image = $(".product-active .product-image img")
                  .last()
                  .attr("src");

                $(".mobile-power-step-title").html(title);
                $(".mobile-power-step-img").attr("src", product_image);

                $(".product-active .mobile-power-step").slideDown(200);
                $("#navbar-mobile-cart-count").show();
                $("#navbar-mobile-cart-count").html(
                  value.replace(/[0-9]+/, cart.item_count)
                );
                $("#recommendations-popup-mobile").html(
                  '<div class="recommended-products cart-recommended-products powerstep-mobile-recommended-products scrolling-wrapper" data-id="' +
                    product_id +
                    '" data-type="power_step" data-scenario="power_step" data-count="4" data-id="" data-container="powerstep-mobile-recommended-products" data-limit="7" data-row-width="3" data-class="lazyload"></div></div>'
                );
                $("#cart_user_identifier").val(
                  localStorage.getItem("user_identifier")
                );
                recommendation_get();
              }

              ga("send", "event", "Added to cart", "click", product_id);
            });
          },
          error: function (XMLHttpRequest) {
            var response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;
            if (response.slice(0, 4) === "All ") {
            } else {
            }
          },
        });
        return false;
      });
    });
  };
  return {
    init: function (params) {
      params = params || {};
      $.extend(_config, params);
      $(function () {
        _init();
      });
    },
    getConfig: function () {
      return _config;
    },
  };
})(jQuery);

ajaxifyCart.init();

function mobile_slider() {
  $(document).ready(function () {
    $(".mobile-slider").not(".slick-initialized").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 100,
      arrows: false,
      dots: false,
      centerMode: true,
      centerPadding: "40px",
      //swipeToSlide: true,
      focusOnSelect: false,
    });
  });
}

function product_template(
  handle,
  image,
  vendor,
  product_title,
  price,
  recommid
) {
  var locale = $("body").data("shop-locale");

  var activeCurrency = $("body").data("currency-symbol");
  var localesToAppend = ["da", "nb", "se"];

  var prependCurrency = "";
  var appendCurrency = "";

  if (localesToAppend.includes(locale)) {
    var appendCurrency = activeCurrency;
  } else {
    var prependCurrency = activeCurrency;
  }

  var template =
    '<div class="collection-product col-md-3 col-xs-6 col-sm-4"> \
				<div class="image"> \
				<a href="/products/' +
    handle +
    "?recommid=" +
    recommid +
    '" class="product-open">\
				<img data-src="' +
    image +
    '" class="lazyload" alt="" /></a>  \
				</div> \
				<div class="details"> \
				<a href="/products' +
    handle +
    '" class="product-open"> </a> \
				<div class="row"><a href="/products/' +
    handle +
    '" class="product-open"> \
				<div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor"> \
				<h3 class="title" style="margin-bottom:5px">' +
    product_title +
    '</h3> \
				<div class="collection-product-vendor-vendor" notranslate=""> ' +
    vendor +
    ' </div>\
				</div>\
				<div class="col-md-4 col-sm-5 ">\
				<div class="price right" notranslate="">\
				<span class="money" data-currency-dkk="' +
    price +
    " " +
    appendCurrency +
    '">' +
    prependCurrency +
    price +
    " " +
    appendCurrency +
    "</span>\
				</div>\
				</div>\
				</a>\
				</div>\
				</div>\
				</div>";

  return template;
}

function product_info_get() {
  var product_id = $(".product-active").data("product-id");

  if (!product_id) {
    return;
  }

  //Cached
  $.getScript(
    "https://cdn.shopify.com/s/files/1/0800/3893/t/6/assets/scripts_product.js?99999525",
    function () {}
  );

  var skus = $(".product-active").data("skus");
  var user_identifier = localStorage.getItem("user_identifier");
  var user_email = localStorage.getItem("user_email");
  var shop_id = $("body").data("shop-id");
  var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  $.ajax({
    type: "GET",
    url:
      "https://env-6539655.jls-sto1.elastx.net/api/products_info/" + product_id,
    data: {
      shop_id: shop_id,
      user_email: user_email,
      user_identifier: user_identifier,
      skus: skus,
      mobile: isMobile,
    },
    dataType: "json",
    success: function (data) {
      $(".product-recommend-products-bottom").html("");

      //get different colors for product
      $.each(data.different_colors, function (i, item) {
        $(".product-different-colors").show();
        $(".product-different-colors-title").show();
        $(".product-different-colors").append(
          '<div class="collection-product col-md-3 col-xs-6" style="padding: 5px;"><a href="/products/' +
            item.handle +
            '" class="product-open" data-keen-name="different_color"><img src="' +
            item.product_image +
            '" alt="' +
            item.title +
            '" style="width:100%"></a></div>'
        );
      });

      //loop through instagram images
      $.each(data.instagram_images, function (i, item) {
        $(".product-instagram").show();
        $(".product-instagram-images").append(
          '<div class="col-md-2 col-sm-4 col-xs-6" style="padding: 5px;">' +
            '<a href="/pages/instagram-embed" class="instagram-image-open" data-id="' +
            item.id +
            "\" onClick=\"ga('send', 'event', 'product instagram images', 'click to view', " +
            item.id +
            ');">' +
            '<div class="product-instagram-images-image" style="overflow:hidden;"><img src="https://thevulcan.io/uploads/instagram/' +
            item.image_vulcan_file +
            '" style="width:100%;     opacity: 0.8;   "></div >' +
            '<div style="margin-top:5px;font-size:10px; color:#999; font-weight: 600; letter-spacing:0.5px" >' +
            item.profile_name +
            "</div></a></div>"
        );
      });

      //loop through recommend products NO LONGER USED REMOVE WHEN WE VERIFY ALTERNATIVE WORKS
      /*$.each(data.recommended_products, function(i, item) {
					     var product_html = product_template(item.handle, item.image, item.vendor, item.product_title, item.price);
					     $(".product-recommend-products-bottom").append(product_html);
		          //$(".product-recommend-products-bottom").append('<div class="collection-product col-md-3 col-xs-6 col-sm-4">  <div class="image">    <a href="/products/'+item.handle+'" class="product-open">      <img src="'+item.image+'" alt="" />    </a>  </div><div class="details">  <a href="/products'+item.handle+'" class="product-open"> </a>  <div class="row"><a href="/products/'+item.handle+'" class="product-open">    <div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor">      <h3 class="title" style="margin-bottom:5px">'+item.product_title+'</h3><div class="collection-product-vendor-vendor" notranslate=""> '+item.vendor+' </div>    </div><div class="col-md-4 col-sm-5 hidden-xs"> <div class="price right" notranslate=""> <span class="money" data-currency-dkk="'+item.price+' kr.">'+item.price+' kr.</span> </div> </div>        </a>  </div>   </div>    </div>');
		        });*/

      //loop through recommend products NO LONGER USED REMOVE WHEN WE VERIFY ALTERNATIVE WORKS
      /*$.each(data.recommended_products_top, function(i, item) {
		          $(".product-recommend-products-top").append('<div class="collection-product col-md-12">  <div class="image">    <a href="/products/'+item.handle+'" class="product-open">      <img src="'+item.image+'" alt="" />    </a>  </div><div class="details">  <a href="/products'+item.handle+'" class="product-open"> </a>  <div class="row"><a href="/products/'+item.handle+'" class="product-open">    <div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor">      <h3 class="title" style="margin-bottom:5px">'+item.product_title+'</h3><div class="collection-product-vendor-vendor" notranslate=""> '+item.vendor+' </div>    </div><div class="col-md-4 col-sm-5 hidden-xs"> <div class="price right" notranslate=""> <span class="money" data-currency-dkk="'+item.price+' kr.">'+item.price+' kr.</span> </div> </div>        </a>  </div>   </div>    </div>');
		        });*/

      if (data.reviews && data.reviews.length > 0) {
        $("#reviews-container").show();
      }

      //loop through reviews
      $.each(data.reviews, function (i, item) {
        if (i > 3) {
          var hide = "display:none";
        } else {
          var hide = "";
        }

        $(".reviews-content").append(
          '<div class="col-md-3 review center" style="margin-bottom:30px;' +
            hide +
            '"><div class="review-bg">' +
            '<div class="rating-stars" data-stars="' +
            item.stars +
            '" id="go-to-reviews" style="font-size:9px;    margin-top:5px;"></div>' +
            '<div style="font-weight:600">' +
            item.title +
            "</div>" +
            '<div style="margin-bottom:10px;color:#666">' +
            item.review +
            "</div>" +
            '<div><span style="color:#777;font-style:italic;font-size:12px">' +
            item.name +
            '</span> &nbsp;<i class="fa fa-check-circle" aria-hidden="true" style="color:#54C98F" data-toggle="tooltip" data-placement="top" title="Brugeren har kĂ¸bt det anmeldte produkt igennem vores shop"></i></div>' +
            "</div></div>"
        );
      });

      if (data.reviews.length > 4) {
        $(".reviews-content").append(
          '<div class="clear center"><a href="#" class="button-with-bottom-border" id="reviews-show-all">Vis alle</a></div>'
        );
      } else {
        $(".reviews-content").append('<div class="clear center"></div>');
      }

      if (isMobile) {
        mobile_slider();
      } else {
        //adjust height
        $(".product-active .product-instagram-images-image").height(
          $(".product-active .product-instagram-images-image").width() + "px"
        );
      }

      console.log("trigger lazyload");
      $(".fire-lazyload").trigger("custom");
    },
  });

  recombeeClient.send(new recombee.AddDetailView(user_identifier, product_id));
}

function recommendation_get() {
  var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  $(".product-active .recommended-products, .cart-recommended-products").each(
    function (i, obj) {
      var type = $(this).data("type");
      var count = $(this).data("count");
      var scenario = $(this).data("scenario");
      var id = $(this).data("id");
      var mobile = $(this).data("mobile");
      var container = $(this).data("container");
      var limit = $(this).data("limit");
      var row_width = $(this).data("row-width");
      var user_identifier = localStorage.getItem("user_identifier");
      var user_email = localStorage.getItem("user_email");
      var shop_id = $("body").data("shop-id");

      if (mobile == "noshow" && isMobile) {
        return true;
      }

      $("." + container).html("");

      var callback = function (err, res) {
        if (err) {
          return;
        }

        $.each(res.recomms, function (index, value) {
          var product_html = product_template(
            value.values.handle,
            value.values.image,
            value.values.vendor,
            value.values.product_title,
            value.values.price,
            res.recommId
          );
          $("." + container).append(product_html);
        });

        $(".fire-lazyload").trigger("custom");
      };

      var product_id = $(".product-active ").data("product-id");
      var user_identifier = localStorage.getItem("user_identifier");
      if (scenario == "cart") {
        recombeeClient.send(
          new recombee.RecommendItemsToUser(user_identifier, count, {
            cascadeCreate: true,
            returnProperties: true,
            includedProperties: [
              "handle",
              "vendor",
              "image",
              "price",
              "product_title",
            ],
            filter:
              " 'type' != \"ramme\" and 'itemId' != \"undefined\" and 'deleted' != true ",
            scenario: scenario,
            logic: "ecommerce:cross-sell",
          }),
          callback
        );
      } else if (scenario == "mobile-home") {
        recombeeClient.send(
          new recombee.RecommendItemsToUser(user_identifier, count, {
            cascadeCreate: true,
            returnProperties: true,
            includedProperties: [
              "handle",
              "vendor",
              "image",
              "price",
              "product_title",
            ],
            filter:
              " 'type' != \"ramme\" and 'itemId' != \"undefined\" and 'deleted' != true ",
            scenario: scenario,
            logic: "ecommerce:homepage",
          }),
          callback
        );
      } else {
        console.log("recommend: " + count);
        recombeeClient.send(
          new recombee.RecommendItemsToItem(id, user_identifier, count, {
            cascadeCreate: true,
            returnProperties: true,
            includedProperties: [
              "handle",
              "vendor",
              "image",
              "price",
              "product_title",
            ],
            filter:
              " 'type' != \"ramme\" and 'itemId' != \"undefined\" and 'deleted' != true ",
            scenario: scenario,
            logic: "ecommerce:cross-sell",
          }),
          callback
        );
      }

      /*
		$.ajax({
	        type : 'GET',
	        url : 'https://thevulcan.io/api/recommendations.php',
	        data: {
			      product_id : id, shop_id : shop_id, scenario : scenario, user_identifier : user_identifier, user_email : user_email, count : count
			 },
	        dataType : 'json',
	        success : function(data){

		        $.each(data.related_products, function(i, item) {
		          $("."+container).append('<div class="collection-product col-md-'+row_width+' col-xs-6 col-sm-4">  <div class="image">    <a href="/products/'+item.handle+'" class="product-open" data-keen-name="'+scenario+'">      <img data-src="'+item.image+'" alt="" class="lazyload"/>    </a>  </div><div class="details">  <a href="/products'+item.handle+'" class="product-open"> </a>  <div class="row"><a href="/products/'+item.handle+'" class="product-open">    <div class="col-md-8 col-sm-7 col-xs-12 collection-product-vendor">      <h3 class="title" style="margin-bottom:5px">'+item.title+'</h3><div class="collection-product-vendor-vendor" notranslate=""> '+item.vendor+' </div>    </div><div class="col-md-4 col-sm-5 hidden-xs"> <div class="price right" notranslate=""> <span class="money" data-currency-dkk="'+item.price+' kr.">'+item.price+' kr.</span> </div> </div>        </a>  </div>   </div>    </div>');
		            return i<limit;
		        });


		        $( ".fire-lazyload").trigger( "custom" );

	        }
	    });
      */
    }
  );
}

function collection_filter() {
  var collection = $(".collection").data("collection");
  var collection_handle = $(".collection").data("collection-handle");
  var shop_id = $("body").data("shop-id");

  if (collection) {
    $.ajax({
      type: "GET",
      url: "https://thevulcan.io/api/filter.php",
      data: {
        vendor: collection,
        shop_id: shop_id,
      },
      dataType: "json",
      success: function (data) {
        $.each(data, function (i, item) {
          // $(".filter-list").append('<li><a href="/collections/'+collection_handle+'/'+item.handle+'">'+item.type+'</a></li>');
        });
      },
    });
  }
}

function get_query_string() {
  var queryStringKeyValue = window.parent.location.search
    .replace("?", "")
    .split("&");
  var qsJsonObject = {};
  if (queryStringKeyValue != "") {
    for (i = 0; i < queryStringKeyValue.length; i++) {
      qsJsonObject[queryStringKeyValue[i].split("=")[0]] = queryStringKeyValue[
        i
      ].split("=")[1];
    }
  }
  return qsJsonObject;
}

function user_action_track(action, product_id, variant_id) {
  var page = window.location.href;
  var user_identifier = localStorage.getItem("user_identifier");
  var user_email = localStorage.getItem("user_email");

  var shop_id = $("body").data("shop-id");

  /*
  $.ajax({
    url: "https://thevulcan.io/track.php?shop_id="+shop_id+"&user_identifier="+user_identifier+"&user_email="+user_email+"&action="+action+"&product_id="+product_id+"&variant_id="+variant_id+"&page_url="+page,
    xhrFields: {withCredentials: true}
  });
  */
}

$(function () {
  $("body").on(
    "click",
    ".modal #recommendations-popup .collection-product a, .mobile-power-step #recommendations-popup-mobile .collection-product a",
    function () {
      ga("send", "event", "Power step", "click", "product");
    }
  );

  $("body").on("click", ".product-usp-read-more", function () {
    $(this).parents(".product-usp").find(".product-usp-text").toggle();
  });

  $("#mobile-menu-more-options").on("click", function () {
    $(this).hide();
    $("#mobile-menu-shop li").show();
  });

  //description

  $(".collection-description").shorten({
    showChars: 190,
    moreText: "Mere",
    lessText: "Mindre",
  });

  $(".collection-description").css({
    "max-height": "initial",
    overflow: "initial",
  });

  var isMobileTablet = /Android|webOS|iPhone|iPod|BlackBerry|iPad/i.test(
    navigator.userAgent
  )
    ? true
    : false;
  var isTablet = /iPad/i.test(navigator.userAgent) ? true : false;
  var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(
    navigator.userAgent
  )
    ? true
    : false;

  var shop_id = $("body").data("shop-id");
  var shop_domain = $("body").data("shop-domain");
  var shop_domain = "moodingsworld.myshopify.com";

  recombeeClient = new recombee.ApiClient(
    "moodings",
    "IGvTSPYOYLmNk8ZeAzhH3UKzC466yJ8Mj0yWsDoo2KnMwVrwS54FcJrGLuHmGn2R"
  );

  if (
    !localStorage.getItem("user_identifier") ||
    localStorage.getItem("user_identifier") == ""
  ) {
    user_identifier =
      Math.random().toString(36).substring(2, 15) +
      Math.random().toString(36).substring(2, 15);

    localStorage.setItem("user_identifier", user_identifier);
  } else {
    user_identifier = localStorage.getItem("user_identifier");
  }

  user_email = localStorage.getItem("user_email")
    ? localStorage.getItem("user_email")
    : "undefined";

  if (get_query_string().email) {
    user_email = get_query_string().email;
  }

  /************
    Tracking
    *************/

  var current_page = encodeURI(window.location.href);

  user_data = "";

  var url = "https://env-6539655.jls-sto1.elastx.net/api/users/track";
  var product_id = 123;

  $.ajax({
    type: "GET",
    dataType: "json",
    url:
      url +
      "?shop_id=" +
      shop_id +
      "&user_email=" +
      user_email +
      "&user_identifier=" +
      user_identifier +
      "&page_url=" +
      current_page +
      "&product_id=" +
      product_id,
    cache: false,
    crossDomain: true,
    xhrFields: { withCredentials: false },
    success: function (data) {
      user_data = data;

      $.each(data.saved_products, function (index, value) {
        var product_id = value.product_id;
        $(".save-product-" + product_id).html('<i class="fa fa-heart"></i>');
      });

      $.each(data.brands_followed, function (index, value) {
        $("[data-follow-brand='" + value.collection + "']").html(
          '<i class="fa fa-heart"></i> &nbsp;Følger'
        );
      });

      if (data.saved_products.length && data.saved_products.length > 0) {
        $(".products-saved-count").html(data.saved_products.length);
        $(".products-saved-count").show();
      }

      if (
        (user_email == "undefined" && data.user_email) ||
        get_query_string().email
      ) {
        localStorage.setItem("user_email", data.user_email);
      }

      $("body").addClass("data-loaded");

      recommendation_get();
    },
  });

  /************
    Save brand
    *************/

  $("body").on("click", ".follow-brand", function () {
    clicked = $(this);
    var collection = clicked.data("follow-brand");
    var user_email = localStorage.getItem("user_email");
    var user_identifier = localStorage.getItem("user_identifier");
    var shop_id = $("body").data("shop-id");

    if (!user_email) {
      $("#myModal-email-form").modal("show");
    }

    if (clicked.find("i").attr("class") == "fa fa-heart-o") {
      //clicked.find('i').removeClass("fa-heart-o").addClass("fa-heart");
      clicked.html('<i class="fa fa-heart"></i> &nbsp;Følger');
      var active = 1;
    } else {
      //clicked.find('i').removeClass("fa-heart").addClass("fa-heart-o");
      clicked.html('<i class="fa fa-heart-o"></i> &nbsp;Følg');
      var active = -1;
    }

    $.post(
      "https://env-6539655.jls-sto1.elastx.net/api/brands/follow",
      {
        collection: collection,
        active: active,
        shop_id: shop_id,
        user_email: user_email,
        user_identifier: user_identifier,
      },
      function (data) {}
    );
  });

  /************
    Save product
    *************/

  $("body").on("click", ".save-product", function () {
    clicked = $(this);
    var product_id = clicked.data("product-id");
    var text = clicked.data("text");
    var user_cookie_email = localStorage.getItem("user_email");
    var user_identifier = localStorage.getItem("user_identifier");
    var shop_id = $("body").data("shop-id");

    if (!user_cookie_email) {
      $("#myModal-email-form").modal("show");
    }

    //change icon

    if (clicked.find("i").attr("class") == "fa fa-heart-o") {
      clicked.find("i").removeClass("fa-heart-o").addClass("fa-heart");
    } else {
      clicked.find("i").removeClass("fa-heart").addClass("fa-heart-o");
    }

    $.get(
      "https://thevulcan.io/model/widgets_submit.php?action=save_product_create&id=" +
        product_id +
        "&shop_id=" +
        shop_id +
        "&user_cookie_id=" +
        user_identifier +
        "&email=" +
        user_cookie_email,
      function (data) {
        if (data == "saved") {
          recombeeClient.send(
            new recombee.AddBookmark(user_identifier, product_id)
          );
          // fbq("track", "AddToWishlist", {
          //   content_ids: [product_id],
          //   content_type: "product",
          // });
          if (text) {
            clicked.html('<i class="fa fa-heart"></i> &nbsp;Gemt');
          }

          var checkDown = parseInt($(".menu-saved-count").text(), 10);

          $(".products-saved-count").html(checkDown + 1);
          $(".products-saved-count").show();
        } else {
          if (text) {
            clicked.html('<i class="fa fa-heart-o"></i> &nbsp;Gem produkt');
          }
        }
      }
    );
    return false;
  });

  /************
    Save email form
    *************/

  $("body").on("submit", ".user-email-form", function () {
    form = $(this);
    var user_email = form.find("#email").val();
    var user_identifier = localStorage.getItem("user_identifier");
    var url = form.attr("action");
    var next_action = form.data("next-action");
    var shop_id = $("body").data("shop-id");
    var shop_domain = $("body").data("shop-domain");

    localStorage.setItem("user_email", user_email);

    $.post(url, {
      shop_id: shop_id,
      user_email: user_email,
      user_identifier: user_identifier,
    });

    if (next_action) {
      form.hide();
      window.location.reload(false);
    } else {
      $("#myModal-email-form").modal("hide");
    }
    return false;
  });

  //saved products

  $("body").on("click", "#products-saved-share-link-show", function () {
    $("#products-saved-share-link").show();
    return false;
  });

  $("body").on("click", "#products-saved-product-remove", function () {
    var url = $(this).attr("href");
    $(this).parents(".collection-product").hide();
    $.get(url);
    return false;
  });

  //add initiate checkout fb event pixel
  $("body").on(
    "click",
    "#cartform .submit, .mobile-power-step .submit",
    function () {
      user_action_track("go_to_checkout", "", "");
      // fbq("track", "InitiateCheckout", {});
      //return false;
    }
  );

  //search
  $(".mobile-search-show").on("click", function () {
    $("#mobile-searching").toggle();
    document.querySelector(".ais-SearchBox-input").focus();
    return false;
  });

  //mobile menu

  $(".mobile-menu-full-open").on("click", function () {
    $("#mobile-menu-full").addClass("opened");
    $("body").addClass("no-scroll");
    return false;
  });

  $(".mobile-menu-close").on("click", function () {
    $("body").removeClass("no-scroll");
    $("#mobile-menu-full").removeClass().addClass("mobile-menu-full");
    return false;
  });

  $(".submenu-open").on("click", function () {
    $(this).parent("li").children("ul").slideToggle(150);

    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).css("font-weight", "normal");
      $(this)
        .children("i")
        .removeClass("fa-angle-down")
        .addClass("fa-angle-right");
    } else {
      $(this).addClass("open");
      $(this).css("font-weight", "600");
      $(this)
        .children("i")
        .removeClass("fa-angle-right")
        .addClass("fa-angle-down");
    }
    return false;
  });

  $(".mobile-menu-show-contact").on("click", function () {
    var cat = $(this).data("cat");
    if (cat === "menu") {
      $(".mobile-menu-full").removeClass().addClass("mobile-menu-full opened");
    } else {
      $(".mobile-menu-full")
        .removeClass()
        .addClass("mobile-menu-full opened " + cat);
    }
    return false;
  });

  //IG images

  var cw = $(".footer-instagram-image").width();
  $(".footer-instagram-image img").css({ height: cw + "px" });

  //open country setings

  $("body").on("click", ".country-settings-open", function () {
    $(".mobile-menu-full-open").trigger("click");
    $(".mobile-menu-full").addClass("country");
  });

  //load products last viewed

  function products_last_viewed(data) {
    $(".products-last_viewed").html("");
    //localStorage.removeItem("last_seen");
    var product_handle = $(".product-active").data("product-handle");
    var product_image = $(".product-active").data("product-image");
    var items = JSON.parse(localStorage.getItem("last_seen"));
    var product = { handle: product_handle, image: product_image };

    if (product_handle) {
      if (items) {
        var a = [];
        a = items;

        if (a.length === 7) {
          a.shift(); //the first item in the array is removed. So length is 2
        }

        a.push(product);
        localStorage.setItem("last_seen", JSON.stringify(a));
      } else {
        var json = [product];
        localStorage.setItem("last_seen", JSON.stringify(json));
      }
    }

    if (items) {
      $.each(items, function (i, item) {
        if (item.handle != product_handle) {
          $(".products-last_viewed").prepend(
            '<div class="col-md-2 collection-product col-xs-6 col-sm-4"><a href="/products/' +
              item.handle +
              '"><img data-src="' +
              item.image +
              '" class="lazyload" style="width:100%"></a></div>'
          );
        }
      });
    }
  }

  products_last_viewed();

  product_info_get();

  function instagram_images() {
    var product_id = $(".product-active").data("product-id");
    var country_locale = $("body").data("shop-locale");

    if (product_id) {
      return;
    }

    if (country_locale == "ko") {
      return;
    }

    if ($("body").hasClass("index")) {
      return;
    }
    //https://thevulcan.io/api/collection_instagram_images.php
    var collection = $(".collection").data("collection");

    $.ajax({
      type: "GET",
      url:
        "https://env-6539655.jls-sto1.elastx.net/api/instagram_widget/" +
        collection,
      data: {
        brand: $(".collection").data("collection"),
        limit: 4,
      },
      dataType: "json",
      success: function (data) {
        $.each(data.instagram_images, function (i, item) {
          $(".collection-instagram-images").append(
            '<div class="col-md-3 col-xs-6 " style="padding: 5px;">' +
              '<a href="/pages/instagram-embed" class="instagram-image-open" data-id="' +
              item.id +
              "\" onClick=\"ga('send', 'event', 'collection instagram images', 'click to view', " +
              item.id +
              ');">' +
              '<div class="collection-instagram-images-image" style="overflow:hidden;"><img src="https://thevulcan.io/uploads/instagram/' +
              item.image +
              '" style="width:100%;     opacity: 0.80;   "></div >' +
              '<div style="margin-top:5px;font-size:8px; color:#999; font-weight: 300;     letter-spacing: 0.7px; color: #999;text-transform: uppercase; text-align:center" >' +
              item.profile_name +
              " " +
              "</div>" +
              "</a></div>"
          );
        });

        if (data.instagram_images.length > 0) {
          $(".collection-instagram").show();
        }

        //adjust height

        if (isMobile) {
          mobile_slider();
        } else {
          $(".collection-instagram-images-image").height(
            $(".collection-instagram-images-image").width() + "px"
          );
        }
      },
    });
  }

  // instagram_images();

  $(".load-image").each(function (index) {
    var src = $(this).data("src");
    $(this).attr("src", src);
  });

  if ($("#admin_bar_iframe").length) {
    $("html").css("margin-top", "-40px").addClass("admin-bar");
  }

  if (isMobile || $(window).width() < 768) {
    $("#frontpage-desktop").remove();
  } else {
    $("#frontpage-mobile").remove();
  }

  // Load JustUno
  window.ju_num = "D239C325-35D8-4DBD-A094-E5669425532B";
  window.asset_host = "//cdn.justuno.com/";
  (function (i, s, o, g, r, a, m) {
    i["JustunoApp"] = r;
    i[r] =
      i[r] ||
      function () {
        (i[r].q = i[r].q || []).push(arguments);
      };
    (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, "script", asset_host + "vck.js", "juapp");

  //modal
  $(".modal").on("shown.bs.modal", function (e) {
    if ($(e.relatedTarget).data("url")) {
      $(".modal-body-content").html(
        '	<iframe src="' +
          $(e.relatedTarget).data("url") +
          '" style="width:100%; height:500px" frameborder="0" allowtransparency="true">'
      );
    }
  });

  //

  $("body").on("click", ".qty-change", function (event) {
    var id = $(this).data("id");
    input = $("#product-quantity-" + id);
    var qty = parseInt(input.val());
    var add = parseInt($(this).data("qty"));
    input.attr("value", qty + add);
    $(this)
      .parent(".cart-line-qty")
      .children("#cart-item-current-qty")
      .html('<i class="fa fa-spinner fa-spin"></i>');
    var datastring = $(".cartform").first().serialize();

    let locale = $("body").data("shop-locale");
    let cartUrl = locale === "da" ? "/cart" : "/" + locale + "/cart";

    $.post("/cart", datastring, function (data) {
      $(".cart-items").load(cartUrl + " .cart-items > div", function () {});
    });
  });

  $("body").on("click", ".cart-item-delete", function (event) {
    var user_identifier = localStorage.getItem("user_identifier");
    var product_id = $(this).data("product-id");

    var line = $(this).data("line");
    var data = {
      quantity: 0,
      line: line,
    };

    //$(this).parents(".cart-line").hide();
    //$(this).closest(".cart-line").next().hide();

    $(this)
      .parent(".cart-line-qty")
      .children("#cart-item-current-qty")
      .html('<i class="fa fa-spinner fa-spin"></i>');

    $.ajax({
      type: "post",
      url: "/cart/change.js",
      data: data,
      success: function (data) {
        var n = data.total_price / 100;
        var value = n.toLocaleString(
          "da-DK", // leave undefined to use the browser's locale,
          // or use a string like 'en-US' to override it.
          { minimumFractionDigits: 2 }
        );

        //$(".cart-total").html(value + " kr.");

        let locale = $("body").data("shop-locale");
        let cartUrl = locale === "da" ? "/cart" : "/" + locale + "/cart";

        $(".cart-items").load(cartUrl + " .cart-items > div", function () {
          $("#cart_user_identifier").val(
            localStorage.getItem("user_identifier")
          );
        });
      },
      dataType: "json",
    });

    //recombeeClient.send(new recombee.DeleteCartAddition(user_identifier, product_id));

    return false;
  });

  // sign up newslwetter form

  $("body").on("submit", ".signup-form", function () {
    var datastring = $(".signup-form").serialize();

    if (!$(".signup-form #contact_email").val()) {
    } else {
      $.post("/contact", datastring)
        .done(function (msg) {
          $(".footer-newsletter-form-response").css("color", "green");
          $(".footer-newsletter-form-response").html("Du er hermed tilmeldt");
        })
        .fail(function (xhr, status, error) {
          $(".footer-newsletter-form-response").css("color", "red");
          $(".footer-newsletter-form-response").html("Der skete en fejl");
        });
    }

    return false;
  });

  //add giftcard post to cart

  $("body").on("click", "#giftcard-post", function () {
    var shop_id = $("body").data("shop-id");

    if (shop_id == 1) {
      var datastring = "id=7601743173";
    } else {
      var datastring = "id=8282858561";
    }

    $(this).append('&nbsp; <i class="fa fa-circle-o-notch fa-spin"></i>&nbsp');

    $.ajax({
      url: "/cart/add.js",
      dataType: "json",
      type: "post",
      data: datastring,
      success: function (result) {
        window.location.href = "/cart";
      },
    });

    return false;
  });

  //instagram image open

  $("body").on("click", ".instagram-image-open", function () {
    $("#myModal-large").modal("show");

    var id = $(this).data("id");

    $.ajax({
      type: "GET",
      url: "https://thevulcan.io/widgets/instagram_embed.php?id=" + id,
      success: function (data) {
        $("#myModal-large .modal-body-content").html(data);
      },
      dataType: "html",
    });

    return false;
  });

  $("#navbar-mobile-search").on("click", function () {
    $("#mobile-search").slideToggle(250);
  });

  $("body").on("click", ".page-category-menu a", function () {
    var tab = $(this).data("tab");
    $(".page-category-menu a").removeClass("page-category-menu-active");
    $(this).addClass("page-category-menu-active");

    $(".page-category-content").hide();
    $(".page-category-" + tab).show();
    return false;
  });

  $(".cart-breadcrumb-link").on("click", function () {
    //$("#cartform").submit();
    $("#checkout").trigger("click");
  });

  //update price and inventory on variant change

  $("body").on("ifChecked", "input", function (event) {
    let inventory = $(this).data("inventory");
    let delivery_time = $(".product-active").data("delivery-time");
    let original_price = $(this).data("original-price");

    $(".product-stock-status").hide();

    if (inventory < 1) {
      $("#" + delivery_time).show();
    } else if (inventory < 4) {
      $("#less-than-five").show();
      $(".inventory-count").html(inventory);
    } else {
      $("#in-stock").show();
      $(".inventory-count").html(inventory);
    }

    $(".current_price").html($(this).data("price") + ".");

    if (original_price) {
      $(".current_price").append("<del>før " + original_price + ".</del>");
    }

    $(".current_price").animate(
      {
        opacity: "0.5",
      },
      250
    );
    setTimeout(function () {
      $(".current_price").animate(
        {
          opacity: "1",
        },
        250
      );
    }, 200);
  });

  if (!isMobile) {
    $("body").on("click", ".product-image .item", function () {
      $(".gallery a").trigger("click");
    });
  }

  $("#collection-change-category-open").on("click", function () {
    $("#collection-menu").removeClass("hidden-xs");
  });

  /**************
    INFINITE SCROLL
    **************/

  function ScrollExecute() {
    if (
      $(document).height() - 1900 <
      $(document).scrollTop() + $(window).height()
    ) {
      //console.log( $(document).height() +'-'+ 1900 +'< '+$(document).scrollTop() +'+'+ $(window).height() );

      scrollNode = $("#more").last();
      scrollURL = $("#more p a").last().attr("href");
      if (scrollNode.length > 0 && scrollNode.css("display") != "none") {
        $.ajax({
          type: "GET",
          url: scrollURL,
          beforeSend: function () {
            $("#more").remove();
            $("#product-list-foot").html(
              '<i class="fa fa-spinner fa-spin"></i>'
            );
          },
          success: function (data) {
            var filteredData = $(data).find(".products .collection-product");
            var more = $(data).find("#more");
            filteredData.insertBefore($("#product-list-foot"));
            more.insertBefore($("#product-list-foot"));
            $("#product-list-foot").html("");

            $.each(user_data.saved_products, function (index, value) {
              var product_id = value.product_id;
              $(".save-product-" + product_id).html(
                '<i class="fa fa-heart"></i>'
              );
            });
          },
          dataType: "html",
        });
      }
    }
  }

  $(window).scroll(function () {
    if (!$("body").hasClass("product-opened")) {
      ScrollExecute();
    }
  });

  /************
    PRODUCT POPUP
  *************/

  //things to active on product load

  product_open_count = "";
  current_path = window.location.pathname;
  var query_string = window.location.search;
  a_new_path = current_path + query_string;
  scroll_from_top = "";

  //do things onload
  var template = $("body").data("template");
  var stateObj = { type: template, url: current_path };

  history.replaceState(stateObj, null, a_new_path);
  console.log(
    "Set state to current path: " +
      current_path +
      " and template to: " +
      template
  );

  $(document).on("click", ".page-open", function () {
    scroll_from_top = 0;
    var href = $(this).attr("href");
    var stateObj = { type: "page", url: href };
    history.pushState(stateObj, null, href);

    $(".mobile-promotion").hide();
    $("#content").css("padding-top", "");
    page_read(href);
    return false;
  });

  //set mobile top menu

  $(document).on("click", ".mobile-menu-top a", function () {
    $(".mobile-menu-top a").removeClass("active");
    $(this).addClass("active");
  });

  $(document).on("click", ".category-open", function () {
    var href = $(this).attr("href");
    var stateObj = { type: "page", url: href, collection: "true" };
    history.pushState(stateObj, null, href);
    page_read(href);
    return false;
  });

  $(document).on("click", ".product-open", function (e) {
    if (e.shiftKey || e.ctrlKey || e.metaKey) {
    } else {
      if (!$("body").hasClass("product-opened")) {
        scroll_from_top = $(document).scrollTop();
      } else {
        $("body").addClass("product-opened");
      }
      console.log("is");

      if (isMobile || isTablet) {
        console.log("mobile");
        $("html, body").animate({ scrollTop: "0px" }, 0);
        window.scrollTo(0, 0);
      } else {
        $("html, body").animate({ scrollTop: "93px" }, 0);
        window.scrollTo(0, 93);
      }

      var href = $(this).attr("href");
      var stateObj = { type: "product", url: href };

      var product_image = $(this).find("img").attr("src");
      var product_title = $(this)
        .parents(".collection-product")
        .find(".collection-product-title")
        .text();
      var product_vendor = $(this)
        .parents(".collection-product")
        .find(".collection-product-vendor-vendor")
        .text();
      var product_price = $(this)
        .parents(".collection-product")
        .find(".collection-product-price")
        .text();
      var product_compare_at_price = $(this)
        .parents(".collection-product")
        .find(".collection-product-compare-at-price")
        .text();
      var product_variant = $(this)
        .parents(".collection-product")
        .data("variant");
      var product_review = $(this)
        .parents(".collection-product")
        .data("review");
      var product = {
        title: product_title,
        vendor: product_vendor,
        img: product_image,
        price: product_price,
        variant: product_variant,
        compare_at_price: product_compare_at_price,
        review: product_review,
      };

      history.pushState(stateObj, null, href);
      product_read(href, product);

      ga("send", "event", "Product type view", "Viewed Product", "product");

      return false;
    }
  });

  $(document).on("click", ".product-close", function () {
    console.log("Go back pages: " + product_open_count);
    history.go(-product_open_count);
    return false;
  });

  $(window).bind("popstate", function (e) {
    console.log("State is being changed");
    state_changed(e.originalEvent.state);
  });

  function state_changed(state) {
    if (state) {
      var type = state.type;
      var url = state.url;
      console.log("State url is: " + url);
      console.log("State type is: " + type);
    }

    if (url == "/search") {
      return;
    }

    //reset mobile menu top
    $(".mobile-menu-top a").removeClass("active");
    $('.mobile-menu-top a[href="' + url + '"]').addClass("active");

    if (type == "page") {
      //check which type of page is in the background
      var div_attr = $("#content-ajax > div").attr("id");
      if ($("body").hasClass("product-opened") && div_attr != "product") {
        product_close();
      } else {
        page_read(url);
      }
    } else if (type == "product") {
      product_read(url);
    }

    console.log("State has changed");
  }

  function page_read(url) {
    product_close();
    $("#content").html("");
    $("html, body").animate({ scrollTop: "0px" }, 0);

    window.scrollTo(0, 0);
    $("#content").load(url + " #content-ajax", function () {
      $(".collection-description").shorten({
        showChars: 190,
        moreText: "Mere",
        lessText: "Mindre",
      });
      if (url == "/") {
        frontpage_image_text();
      }
      collection_filter();
    });

    console.log("Read page with url: " + url);
  }

  function product_read(url, product) {
    //window.globalVar = product.img;

    /*
        if(product){
          $(".product-popup-placeholder .product-information").show();
          $(".product-popup-placeholder .product-brand").html(product.vendor);
          $(".product-popup-placeholder .product-popup-placeholder-title").html(product.title);
          $(".product-popup-placeholder .product-description").html('&nbsp;');
          $(".product-popup-placeholder .current_price").html(product.price+".");
          $(".product-popup-placeholder .product-popup-compare").html("");
          $(".product-popup-placeholder .product-popup-size").html(product.variant);
          $(".product-popup-placeholder .product-popup-image img").attr("src", product.img);

          if(product.compare_at_price != ''){
            $(".product-popup-placeholder .product-popup-compare").html("før "+product.compare_at_price);
          }

          if(product.review != ''){
            $(".product-popup-rating-stars").show();
          }else{
            $(".product-popup-rating-stars").hide();
          }
        }

        $.getJSON( url+".json", function( data ) {
	          $(".product-popup-placeholder .product-popup-image img").attr("src", data.product.image.src);

            var showChar = 199;
            var content = data.product.body_html;

            if(content.length > showChar) {

              var c = content.substr(0, showChar);
              var h = content.substr(showChar-1, content.length - showChar);
              var html = c + '... Mere';
              $(".product-popup-placeholder .product-description").html(html);

            }else{
              $(".product-popup-placeholder .product-description").html(content);
            }


            if(data.product.variants[0].inventory_quantity <1){
              $(".product-popup-placeholder .product-stock-status-headline").html("På fjernlager - op til 14 dages levering");
              //$(".product-popup-placeholder .product-stock-status-desc").html('Op til 14 dages levering');
            }else{
              $(".product-popup-placeholder .product-stock-status-headline").html("På lager: 1-2 dages levering");
              //$(".product-popup-placeholder .product-stock-status-desc").html("Produktet er på lager");
            }

        });

*/

    $(".product").removeClass("product-active");

    if ($("body").hasClass("product-opened")) {
      product_open_count++;
      $("#product-popup-content").html("");
    } else {
      product_open_count = 1;
      $("body").addClass("product-opened");
      $("#product-popup").show();
      var screen_width = $("#product-popup-image").width() / 1.33;
      $("#product-popup-image").css("height", screen_width);
      $("#content").hide();
      $("#navbar-mobile-content").hide();
    }

    $("#product-popup-content").load(url + " #content-ajax", function () {
      //fix product image container height
      $("#product-popup-placeholder").hide();
      $("#product-popup-footer").html("");
      $("#footer-new").clone().appendTo("#product-popup-footer");

      var product_id = $(".product-popup  #product").data("product-id");

      product_info_get();
      products_last_viewed();

      if (user_data.saved_products) {
        $.each(user_data.saved_products, function (index, value) {
          var product_id = value.product_id;
          $(".save-product-" + product_id).html('<i class="fa fa-heart"></i>');
        });
      }

      //load product images and hide the placeholder image on loaded
      $(".product-image img")
        .one("load", function () {
          setTimeout(function () {}, 200);
        })
        .each(function () {
          if (this.complete) $(this).load();
        });

      // fbq("track", "ViewContent", {
      //   content_ids: [product_id],
      //   content_type: "product",
      // });

      var trustbox = document.getElementById("trustbox");
      if (trustbox) {
        window.Trustpilot.loadFromElement(trustbox);
      }
    });
  }

  function product_close() {
    $("#content").css("visibility", "hidden");
    $("#content").show();
    $("#page-container .footer").show();
    $("#navbar-mobile-content").show();
    $("#product-popup").hide();
    $("#product-popup-content").html("");
    $("#product-popup-image img").attr("src", "");
    $("#product-popup-placeholder").show();
    $("body").removeClass("product-opened");

    setTimeout(function () {
      $("html,body").animate({ scrollTop: scroll_from_top + "px" }, 10);
      window.scrollTo(0, scroll_from_top);

      setTimeout(function () {
        $("#content").css("visibility", "visible");
      }, 40);
    }, 200);

    //user_action_track('close_product', '', '');
    console.log("Close product and show page at: " + scroll_from_top);
  }

  /****************
    PRODUCT POPUP END
    ****************/

  //do things just on mobile

  if (isMobileTablet) {
  } else {
    //do things just on desktop

    $(window).scroll(function () {
      var scroll = $(window).scrollTop();

      if (scroll >= 148) {
        $(".navbar").addClass("header-fixed");
        $(".main").addClass("main-fixed");

        $("#logo-menu").show();
      } else {
        $(".navbar").removeClass("header-fixed");
        $(".main").removeClass("main-fixed");
        $("#logo-menu").hide();
      }
    });
  }

  //do things just on tablet

  if (isTablet) {
    $(".remove-link").removeAttr("href");

    var megaMenu = $(".menu");
    $(".dropdown", megaMenu).hide();
    $("li", megaMenu).click(function () {
      var me = $(this);
      $(".dropdown", me).slideToggle(200);
    });
  }

  //do things just on desktop

  if (!isMobileTablet) {
    (function () {
      // drop down delay

      var megaMenu = $(".menu, .navbar-icons");

      // hide all dropdowns
      $(".dropdown", megaMenu).hide();

      $("li", megaMenu).hover(
        function () {
          // on hover In
          var me = $(this);

          // flag to indicate that the mouse
          // has not left the area
          me.attr("mIn", "true");

          setTimeout(function () {
            // if the mouse is still in
            if (me.attr("mIn") == "true") {
              //show the drop down
              $(".dropdown", me).slideDown(100);
            }
          }, 250);
        },
        function () {
          // on hover out

          // set the flag as the mouse has left
          $(this).attr("mIn", "false");

          // hide the drop down

          var me = $(this);

          setTimeout(function () {
            // if the mouse is still in
            if (me.attr("mIn") == "false") {
              //show the drop down
              $(".dropdown", me).slideUp(150);
            }
          }, 250);
        }
      );
    })();
  }
});

/*slick slider*/
!(function (i) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], i)
    : "undefined" != typeof exports
    ? (module.exports = i(require("jquery")))
    : i(jQuery);
})(function (i) {
  "use strict";
  var e = window.Slick || {};
  ((e = (function () {
    function e(e, o) {
      var s,
        n = this;
      (n.defaults = {
        accessibility: !0,
        adaptiveHeight: !1,
        appendArrows: i(e),
        appendDots: i(e),
        arrows: !0,
        asNavFor: null,
        prevArrow:
          '<button type="button" data-role="none" class="slick-prev" aria-label="Previous" tabindex="0" role="button">Previous</button>',
        nextArrow:
          '<button type="button" data-role="none" class="slick-next" aria-label="Next" tabindex="0" role="button">Next</button>',
        autoplay: !1,
        autoplaySpeed: 3e3,
        centerMode: !1,
        centerPadding: "50px",
        cssEase: "ease",
        customPaging: function (e, t) {
          return i(
            '<button type="button" data-role="none" role="button" tabindex="0" />'
          ).text(t + 1);
        },
        dots: !1,
        dotsClass: "slick-dots",
        draggable: !0,
        easing: "linear",
        edgeFriction: 0.35,
        fade: !1,
        focusOnSelect: !1,
        infinite: !0,
        initialSlide: 0,
        lazyLoad: "ondemand",
        mobileFirst: !1,
        pauseOnHover: !0,
        pauseOnFocus: !0,
        pauseOnDotsHover: !1,
        respondTo: "window",
        responsive: null,
        rows: 1,
        rtl: !1,
        slide: "",
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        swipe: !0,
        swipeToSlide: !1,
        touchMove: !0,
        touchThreshold: 5,
        useCSS: !0,
        useTransform: !0,
        variableWidth: !1,
        vertical: !1,
        verticalSwiping: !1,
        waitForAnimate: !0,
        zIndex: 1e3,
      }),
        (n.initials = {
          animating: !1,
          dragging: !1,
          autoPlayTimer: null,
          currentDirection: 0,
          currentLeft: null,
          currentSlide: 0,
          direction: 1,
          $dots: null,
          listWidth: null,
          listHeight: null,
          loadIndex: 0,
          $nextArrow: null,
          $prevArrow: null,
          slideCount: null,
          slideWidth: null,
          $slideTrack: null,
          $slides: null,
          sliding: !1,
          slideOffset: 0,
          swipeLeft: null,
          $list: null,
          touchObject: {},
          transformsEnabled: !1,
          unslicked: !1,
        }),
        i.extend(n, n.initials),
        (n.activeBreakpoint = null),
        (n.animType = null),
        (n.animProp = null),
        (n.breakpoints = []),
        (n.breakpointSettings = []),
        (n.cssTransitions = !1),
        (n.focussed = !1),
        (n.interrupted = !1),
        (n.hidden = "hidden"),
        (n.paused = !0),
        (n.positionProp = null),
        (n.respondTo = null),
        (n.rowCount = 1),
        (n.shouldClick = !0),
        (n.$slider = i(e)),
        (n.$slidesCache = null),
        (n.transformType = null),
        (n.transitionType = null),
        (n.visibilityChange = "visibilitychange"),
        (n.windowWidth = 0),
        (n.windowTimer = null),
        (s = i(e).data("slick") || {}),
        (n.options = i.extend({}, n.defaults, o, s)),
        (n.currentSlide = n.options.initialSlide),
        (n.originalSettings = n.options),
        void 0 !== document.mozHidden
          ? ((n.hidden = "mozHidden"),
            (n.visibilityChange = "mozvisibilitychange"))
          : void 0 !== document.webkitHidden &&
            ((n.hidden = "webkitHidden"),
            (n.visibilityChange = "webkitvisibilitychange")),
        (n.autoPlay = i.proxy(n.autoPlay, n)),
        (n.autoPlayClear = i.proxy(n.autoPlayClear, n)),
        (n.autoPlayIterator = i.proxy(n.autoPlayIterator, n)),
        (n.changeSlide = i.proxy(n.changeSlide, n)),
        (n.clickHandler = i.proxy(n.clickHandler, n)),
        (n.selectHandler = i.proxy(n.selectHandler, n)),
        (n.setPosition = i.proxy(n.setPosition, n)),
        (n.swipeHandler = i.proxy(n.swipeHandler, n)),
        (n.dragHandler = i.proxy(n.dragHandler, n)),
        (n.keyHandler = i.proxy(n.keyHandler, n)),
        (n.instanceUid = t++),
        (n.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/),
        n.registerBreakpoints(),
        n.init(!0);
    }
    var t = 0;
    return e;
  })()).prototype.activateADA = function () {
    this.$slideTrack
      .find(".slick-active")
      .attr({ "aria-hidden": "false" })
      .find("a, input, button, select")
      .attr({ tabindex: "0" });
  }),
    (e.prototype.addSlide = e.prototype.slickAdd = function (e, t, o) {
      var s = this;
      if ("boolean" == typeof t) (o = t), (t = null);
      else if (0 > t || t >= s.slideCount) return !1;
      s.unload(),
        "number" == typeof t
          ? 0 === t && 0 === s.$slides.length
            ? i(e).appendTo(s.$slideTrack)
            : o
            ? i(e).insertBefore(s.$slides.eq(t))
            : i(e).insertAfter(s.$slides.eq(t))
          : !0 === o
          ? i(e).prependTo(s.$slideTrack)
          : i(e).appendTo(s.$slideTrack),
        (s.$slides = s.$slideTrack.children(this.options.slide)),
        s.$slideTrack.children(this.options.slide).detach(),
        s.$slideTrack.append(s.$slides),
        s.$slides.each(function (e, t) {
          i(t).attr("data-slick-index", e);
        }),
        (s.$slidesCache = s.$slides),
        s.reinit();
    }),
    (e.prototype.animateHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.animate({ height: e }, i.options.speed);
      }
    }),
    (e.prototype.animateSlide = function (e, t) {
      var o = {},
        s = this;
      s.animateHeight(),
        !0 === s.options.rtl && !1 === s.options.vertical && (e = -e),
        !1 === s.transformsEnabled
          ? !1 === s.options.vertical
            ? s.$slideTrack.animate(
                { left: e },
                s.options.speed,
                s.options.easing,
                t
              )
            : s.$slideTrack.animate(
                { top: e },
                s.options.speed,
                s.options.easing,
                t
              )
          : !1 === s.cssTransitions
          ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft),
            i({ animStart: s.currentLeft }).animate(
              { animStart: e },
              {
                duration: s.options.speed,
                easing: s.options.easing,
                step: function (i) {
                  (i = Math.ceil(i)),
                    !1 === s.options.vertical
                      ? ((o[s.animType] = "translate(" + i + "px, 0px)"),
                        s.$slideTrack.css(o))
                      : ((o[s.animType] = "translate(0px," + i + "px)"),
                        s.$slideTrack.css(o));
                },
                complete: function () {
                  t && t.call();
                },
              }
            ))
          : (s.applyTransition(),
            (e = Math.ceil(e)),
            !1 === s.options.vertical
              ? (o[s.animType] = "translate3d(" + e + "px, 0px, 0px)")
              : (o[s.animType] = "translate3d(0px," + e + "px, 0px)"),
            s.$slideTrack.css(o),
            t &&
              setTimeout(function () {
                s.disableTransition(), t.call();
              }, s.options.speed));
    }),
    (e.prototype.getNavTarget = function () {
      var e = this,
        t = e.options.asNavFor;
      return t && null !== t && (t = i(t).not(e.$slider)), t;
    }),
    (e.prototype.asNavFor = function (e) {
      var t = this.getNavTarget();
      null !== t &&
        "object" == typeof t &&
        t.each(function () {
          var t = i(this).slick("getSlick");
          t.unslicked || t.slideHandler(e, !0);
        });
    }),
    (e.prototype.applyTransition = function (i) {
      var e = this,
        t = {};
      !1 === e.options.fade
        ? (t[e.transitionType] =
            e.transformType + " " + e.options.speed + "ms " + e.options.cssEase)
        : (t[e.transitionType] =
            "opacity " + e.options.speed + "ms " + e.options.cssEase),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.autoPlay = function () {
      var i = this;
      i.autoPlayClear(),
        i.slideCount > i.options.slidesToShow &&
          (i.autoPlayTimer = setInterval(
            i.autoPlayIterator,
            i.options.autoplaySpeed
          ));
    }),
    (e.prototype.autoPlayClear = function () {
      var i = this;
      i.autoPlayTimer && clearInterval(i.autoPlayTimer);
    }),
    (e.prototype.autoPlayIterator = function () {
      var i = this,
        e = i.currentSlide + i.options.slidesToScroll;
      i.paused ||
        i.interrupted ||
        i.focussed ||
        (!1 === i.options.infinite &&
          (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1
            ? (i.direction = 0)
            : 0 === i.direction &&
              ((e = i.currentSlide - i.options.slidesToScroll),
              i.currentSlide - 1 == 0 && (i.direction = 1))),
        i.slideHandler(e));
    }),
    (e.prototype.buildArrows = function () {
      var e = this;
      !0 === e.options.arrows &&
        ((e.$prevArrow = i(e.options.prevArrow).addClass("slick-arrow")),
        (e.$nextArrow = i(e.options.nextArrow).addClass("slick-arrow")),
        e.slideCount > e.options.slidesToShow
          ? (e.$prevArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.$nextArrow
              .removeClass("slick-hidden")
              .removeAttr("aria-hidden tabindex"),
            e.htmlExpr.test(e.options.prevArrow) &&
              e.$prevArrow.prependTo(e.options.appendArrows),
            e.htmlExpr.test(e.options.nextArrow) &&
              e.$nextArrow.appendTo(e.options.appendArrows),
            !0 !== e.options.infinite &&
              e.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"))
          : e.$prevArrow
              .add(e.$nextArrow)
              .addClass("slick-hidden")
              .attr({ "aria-disabled": "true", tabindex: "-1" }));
    }),
    (e.prototype.buildDots = function () {
      var e,
        t,
        o = this;
      if (!0 === o.options.dots && o.slideCount > o.options.slidesToShow) {
        for (
          o.$slider.addClass("slick-dotted"),
            t = i("<ul />").addClass(o.options.dotsClass),
            e = 0;
          e <= o.getDotCount();
          e += 1
        )
          t.append(i("<li />").append(o.options.customPaging.call(this, o, e)));
        (o.$dots = t.appendTo(o.options.appendDots)),
          o.$dots
            .find("li")
            .first()
            .addClass("slick-active")
            .attr("aria-hidden", "false");
      }
    }),
    (e.prototype.buildOut = function () {
      var e = this;
      (e.$slides = e.$slider
        .children(e.options.slide + ":not(.slick-cloned)")
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.$slides.each(function (e, t) {
          i(t)
            .attr("data-slick-index", e)
            .data("originalStyling", i(t).attr("style") || "");
        }),
        e.$slider.addClass("slick-slider"),
        (e.$slideTrack =
          0 === e.slideCount
            ? i('<div class="slick-track"/>').appendTo(e.$slider)
            : e.$slides.wrapAll('<div class="slick-track"/>').parent()),
        (e.$list = e.$slideTrack
          .wrap('<div aria-live="polite" class="slick-list"/>')
          .parent()),
        e.$slideTrack.css("opacity", 0),
        (!0 === e.options.centerMode || !0 === e.options.swipeToSlide) &&
          (e.options.slidesToScroll = 1),
        i("img[data-lazy]", e.$slider).not("[src]").addClass("slick-loading"),
        e.setupInfinite(),
        e.buildArrows(),
        e.buildDots(),
        e.updateDots(),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        !0 === e.options.draggable && e.$list.addClass("draggable");
    }),
    (e.prototype.buildRows = function () {
      var i,
        e,
        t,
        o,
        s,
        n,
        r,
        l = this;
      if (
        ((o = document.createDocumentFragment()),
        (n = l.$slider.children()),
        l.options.rows > 1)
      ) {
        for (
          r = l.options.slidesPerRow * l.options.rows,
            s = Math.ceil(n.length / r),
            i = 0;
          s > i;
          i++
        ) {
          var d = document.createElement("div");
          for (e = 0; e < l.options.rows; e++) {
            var a = document.createElement("div");
            for (t = 0; t < l.options.slidesPerRow; t++) {
              var c = i * r + (e * l.options.slidesPerRow + t);
              n.get(c) && a.appendChild(n.get(c));
            }
            d.appendChild(a);
          }
          o.appendChild(d);
        }
        l.$slider.empty().append(o),
          l.$slider
            .children()
            .children()
            .children()
            .css({
              width: 100 / l.options.slidesPerRow + "%",
              display: "inline-block",
            });
      }
    }),
    (e.prototype.checkResponsive = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = !1,
        d = r.$slider.width(),
        a = window.innerWidth || i(window).width();
      if (
        ("window" === r.respondTo
          ? (n = a)
          : "slider" === r.respondTo
          ? (n = d)
          : "min" === r.respondTo && (n = Math.min(a, d)),
        r.options.responsive &&
          r.options.responsive.length &&
          null !== r.options.responsive)
      ) {
        s = null;
        for (o in r.breakpoints)
          r.breakpoints.hasOwnProperty(o) &&
            (!1 === r.originalSettings.mobileFirst
              ? n < r.breakpoints[o] && (s = r.breakpoints[o])
              : n > r.breakpoints[o] && (s = r.breakpoints[o]));
        null !== s
          ? null !== r.activeBreakpoint
            ? (s !== r.activeBreakpoint || t) &&
              ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
            : ((r.activeBreakpoint = s),
              "unslick" === r.breakpointSettings[s]
                ? r.unslick(s)
                : ((r.options = i.extend(
                    {},
                    r.originalSettings,
                    r.breakpointSettings[s]
                  )),
                  !0 === e && (r.currentSlide = r.options.initialSlide),
                  r.refresh(e)),
              (l = s))
          : null !== r.activeBreakpoint &&
            ((r.activeBreakpoint = null),
            (r.options = r.originalSettings),
            !0 === e && (r.currentSlide = r.options.initialSlide),
            r.refresh(e),
            (l = s)),
          e || !1 === l || r.$slider.trigger("breakpoint", [r, l]);
      }
    }),
    (e.prototype.changeSlide = function (e, t) {
      var o,
        s,
        n,
        r = this,
        l = i(e.currentTarget);
      switch (
        (l.is("a") && e.preventDefault(),
        l.is("li") || (l = l.closest("li")),
        (n = r.slideCount % r.options.slidesToScroll != 0),
        (o = n
          ? 0
          : (r.slideCount - r.currentSlide) % r.options.slidesToScroll),
        e.data.message)
      ) {
        case "previous":
          (s = 0 === o ? r.options.slidesToScroll : r.options.slidesToShow - o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide - s, !1, t);
          break;
        case "next":
          (s = 0 === o ? r.options.slidesToScroll : o),
            r.slideCount > r.options.slidesToShow &&
              r.slideHandler(r.currentSlide + s, !1, t);
          break;
        case "index":
          var d =
            0 === e.data.index
              ? 0
              : e.data.index || l.index() * r.options.slidesToScroll;
          r.slideHandler(r.checkNavigable(d), !1, t),
            l.children().trigger("focus");
          break;
        default:
          return;
      }
    }),
    (e.prototype.checkNavigable = function (i) {
      var e, t;
      if (((e = this.getNavigableIndexes()), (t = 0), i > e[e.length - 1]))
        i = e[e.length - 1];
      else
        for (var o in e) {
          if (i < e[o]) {
            i = t;
            break;
          }
          t = e[o];
        }
      return i;
    }),
    (e.prototype.cleanUpEvents = function () {
      var e = this;
      e.options.dots &&
        null !== e.$dots &&
        i("li", e.$dots)
          .off("click.slick", e.changeSlide)
          .off("mouseenter.slick", i.proxy(e.interrupt, e, !0))
          .off("mouseleave.slick", i.proxy(e.interrupt, e, !1)),
        e.$slider.off("focus.slick blur.slick"),
        !0 === e.options.arrows &&
          e.slideCount > e.options.slidesToShow &&
          (e.$prevArrow && e.$prevArrow.off("click.slick", e.changeSlide),
          e.$nextArrow && e.$nextArrow.off("click.slick", e.changeSlide)),
        e.$list.off("touchstart.slick mousedown.slick", e.swipeHandler),
        e.$list.off("touchmove.slick mousemove.slick", e.swipeHandler),
        e.$list.off("touchend.slick mouseup.slick", e.swipeHandler),
        e.$list.off("touchcancel.slick mouseleave.slick", e.swipeHandler),
        e.$list.off("click.slick", e.clickHandler),
        i(document).off(e.visibilityChange, e.visibility),
        e.cleanUpSlideEvents(),
        !0 === e.options.accessibility &&
          e.$list.off("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().off("click.slick", e.selectHandler),
        i(window).off(
          "orientationchange.slick.slick-" + e.instanceUid,
          e.orientationChange
        ),
        i(window).off("resize.slick.slick-" + e.instanceUid, e.resize),
        i("[draggable!=true]", e.$slideTrack).off(
          "dragstart",
          e.preventDefault
        ),
        i(window).off("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(document).off("ready.slick.slick-" + e.instanceUid, e.setPosition);
    }),
    (e.prototype.cleanUpSlideEvents = function () {
      var e = this;
      e.$list.off("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.off("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.cleanUpRows = function () {
      var i,
        e = this;
      e.options.rows > 1 &&
        ((i = e.$slides.children().children()).removeAttr("style"),
        e.$slider.empty().append(i));
    }),
    (e.prototype.clickHandler = function (i) {
      !1 === this.shouldClick &&
        (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault());
    }),
    (e.prototype.destroy = function (e) {
      var t = this;
      t.autoPlayClear(),
        (t.touchObject = {}),
        t.cleanUpEvents(),
        i(".slick-cloned", t.$slider).detach(),
        t.$dots && t.$dots.remove(),
        t.$prevArrow &&
          t.$prevArrow.length &&
          (t.$prevArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.prevArrow) && t.$prevArrow.remove()),
        t.$nextArrow &&
          t.$nextArrow.length &&
          (t.$nextArrow
            .removeClass("slick-disabled slick-arrow slick-hidden")
            .removeAttr("aria-hidden aria-disabled tabindex")
            .css("display", ""),
          t.htmlExpr.test(t.options.nextArrow) && t.$nextArrow.remove()),
        t.$slides &&
          (t.$slides
            .removeClass(
              "slick-slide slick-active slick-center slick-visible slick-current"
            )
            .removeAttr("aria-hidden")
            .removeAttr("data-slick-index")
            .each(function () {
              i(this).attr("style", i(this).data("originalStyling"));
            }),
          t.$slideTrack.children(this.options.slide).detach(),
          t.$slideTrack.detach(),
          t.$list.detach(),
          t.$slider.append(t.$slides)),
        t.cleanUpRows(),
        t.$slider.removeClass("slick-slider"),
        t.$slider.removeClass("slick-initialized"),
        t.$slider.removeClass("slick-dotted"),
        (t.unslicked = !0),
        e || t.$slider.trigger("destroy", [t]);
    }),
    (e.prototype.disableTransition = function (i) {
      var e = this,
        t = {};
      (t[e.transitionType] = ""),
        !1 === e.options.fade ? e.$slideTrack.css(t) : e.$slides.eq(i).css(t);
    }),
    (e.prototype.fadeSlide = function (i, e) {
      var t = this;
      !1 === t.cssTransitions
        ? (t.$slides.eq(i).css({ zIndex: t.options.zIndex }),
          t.$slides
            .eq(i)
            .animate({ opacity: 1 }, t.options.speed, t.options.easing, e))
        : (t.applyTransition(i),
          t.$slides.eq(i).css({ opacity: 1, zIndex: t.options.zIndex }),
          e &&
            setTimeout(function () {
              t.disableTransition(i), e.call();
            }, t.options.speed));
    }),
    (e.prototype.fadeSlideOut = function (i) {
      var e = this;
      !1 === e.cssTransitions
        ? e.$slides
            .eq(i)
            .animate(
              { opacity: 0, zIndex: e.options.zIndex - 2 },
              e.options.speed,
              e.options.easing
            )
        : (e.applyTransition(i),
          e.$slides.eq(i).css({ opacity: 0, zIndex: e.options.zIndex - 2 }));
    }),
    (e.prototype.filterSlides = e.prototype.slickFilter = function (i) {
      var e = this;
      null !== i &&
        ((e.$slidesCache = e.$slides),
        e.unload(),
        e.$slideTrack.children(this.options.slide).detach(),
        e.$slidesCache.filter(i).appendTo(e.$slideTrack),
        e.reinit());
    }),
    (e.prototype.focusHandler = function () {
      var e = this;
      e.$slider
        .off("focus.slick blur.slick")
        .on("focus.slick blur.slick", "*:not(.slick-arrow)", function (t) {
          t.stopImmediatePropagation();
          var o = i(this);
          setTimeout(function () {
            e.options.pauseOnFocus &&
              ((e.focussed = o.is(":focus")), e.autoPlay());
          }, 0);
        });
    }),
    (e.prototype.getCurrent = e.prototype.slickCurrentSlide = function () {
      return this.currentSlide;
    }),
    (e.prototype.getDotCount = function () {
      var i = this,
        e = 0,
        t = 0,
        o = 0;
      if (!0 === i.options.infinite)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow
                ? i.options.slidesToScroll
                : i.options.slidesToShow);
      else if (!0 === i.options.centerMode) o = i.slideCount;
      else if (i.options.asNavFor)
        for (; e < i.slideCount; )
          ++o,
            (e = t + i.options.slidesToScroll),
            (t +=
              i.options.slidesToScroll <= i.options.slidesToShow
                ? i.options.slidesToScroll
                : i.options.slidesToShow);
      else
        o =
          1 +
          Math.ceil(
            (i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll
          );
      return o - 1;
    }),
    (e.prototype.getLeft = function (i) {
      var e,
        t,
        o,
        s = this,
        n = 0;
      return (
        (s.slideOffset = 0),
        (t = s.$slides.first().outerHeight(!0)),
        !0 === s.options.infinite
          ? (s.slideCount > s.options.slidesToShow &&
              ((s.slideOffset = s.slideWidth * s.options.slidesToShow * -1),
              (n = t * s.options.slidesToShow * -1)),
            s.slideCount % s.options.slidesToScroll != 0 &&
              i + s.options.slidesToScroll > s.slideCount &&
              s.slideCount > s.options.slidesToShow &&
              (i > s.slideCount
                ? ((s.slideOffset =
                    (s.options.slidesToShow - (i - s.slideCount)) *
                    s.slideWidth *
                    -1),
                  (n = (s.options.slidesToShow - (i - s.slideCount)) * t * -1))
                : ((s.slideOffset =
                    (s.slideCount % s.options.slidesToScroll) *
                    s.slideWidth *
                    -1),
                  (n = (s.slideCount % s.options.slidesToScroll) * t * -1))))
          : i + s.options.slidesToShow > s.slideCount &&
            ((s.slideOffset =
              (i + s.options.slidesToShow - s.slideCount) * s.slideWidth),
            (n = (i + s.options.slidesToShow - s.slideCount) * t)),
        s.slideCount <= s.options.slidesToShow &&
          ((s.slideOffset = 0), (n = 0)),
        !0 === s.options.centerMode && !0 === s.options.infinite
          ? (s.slideOffset +=
              s.slideWidth * Math.floor(s.options.slidesToShow / 2) -
              s.slideWidth)
          : !0 === s.options.centerMode &&
            ((s.slideOffset = 0),
            (s.slideOffset +=
              s.slideWidth * Math.floor(s.options.slidesToShow / 2))),
        (e =
          !1 === s.options.vertical
            ? i * s.slideWidth * -1 + s.slideOffset
            : i * t * -1 + n),
        !0 === s.options.variableWidth &&
          ((o =
            s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite
              ? s.$slideTrack.children(".slick-slide").eq(i)
              : s.$slideTrack
                  .children(".slick-slide")
                  .eq(i + s.options.slidesToShow)),
          (e =
            !0 === s.options.rtl
              ? o[0]
                ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width())
                : 0
              : o[0]
              ? -1 * o[0].offsetLeft
              : 0),
          !0 === s.options.centerMode &&
            ((o =
              s.slideCount <= s.options.slidesToShow ||
              !1 === s.options.infinite
                ? s.$slideTrack.children(".slick-slide").eq(i)
                : s.$slideTrack
                    .children(".slick-slide")
                    .eq(i + s.options.slidesToShow + 1)),
            (e =
              !0 === s.options.rtl
                ? o[0]
                  ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width())
                  : 0
                : o[0]
                ? -1 * o[0].offsetLeft
                : 0),
            (e += (s.$list.width() - o.outerWidth()) / 2))),
        e
      );
    }),
    (e.prototype.getOption = e.prototype.slickGetOption = function (i) {
      return this.options[i];
    }),
    (e.prototype.getNavigableIndexes = function () {
      var i,
        e = this,
        t = 0,
        o = 0,
        s = [];
      for (
        !1 === e.options.infinite
          ? (i = e.slideCount)
          : ((t = -1 * e.options.slidesToScroll),
            (o = -1 * e.options.slidesToScroll),
            (i = 2 * e.slideCount));
        i > t;

      )
        s.push(t),
          (t = o + e.options.slidesToScroll),
          (o +=
            e.options.slidesToScroll <= e.options.slidesToShow
              ? e.options.slidesToScroll
              : e.options.slidesToShow);
      return s;
    }),
    (e.prototype.getSlick = function () {
      return this;
    }),
    (e.prototype.getSlideCount = function () {
      var e,
        t,
        o = this;
      return (
        (t =
          !0 === o.options.centerMode
            ? o.slideWidth * Math.floor(o.options.slidesToShow / 2)
            : 0),
        !0 === o.options.swipeToSlide
          ? (o.$slideTrack.find(".slick-slide").each(function (s, n) {
              return n.offsetLeft - t + i(n).outerWidth() / 2 > -1 * o.swipeLeft
                ? ((e = n), !1)
                : void 0;
            }),
            Math.abs(i(e).attr("data-slick-index") - o.currentSlide) || 1)
          : o.options.slidesToScroll
      );
    }),
    (e.prototype.goTo = e.prototype.slickGoTo = function (i, e) {
      this.changeSlide({ data: { message: "index", index: parseInt(i) } }, e);
    }),
    (e.prototype.init = function (e) {
      var t = this;
      i(t.$slider).hasClass("slick-initialized") ||
        (i(t.$slider).addClass("slick-initialized"),
        t.buildRows(),
        t.buildOut(),
        t.setProps(),
        t.startLoad(),
        t.loadSlider(),
        t.initializeEvents(),
        t.updateArrows(),
        t.updateDots(),
        t.checkResponsive(!0),
        t.focusHandler()),
        e && t.$slider.trigger("init", [t]),
        !0 === t.options.accessibility && t.initADA(),
        t.options.autoplay && ((t.paused = !1), t.autoPlay());
    }),
    (e.prototype.initADA = function () {
      var e = this;
      e.$slides
        .add(e.$slideTrack.find(".slick-cloned"))
        .attr({ "aria-hidden": "true", tabindex: "-1" })
        .find("a, input, button, select")
        .attr({ tabindex: "-1" }),
        e.$slideTrack.attr("role", "listbox"),
        e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function (t) {
          i(this).attr({
            role: "option",
            "aria-describedby": "slick-slide" + e.instanceUid + t,
          });
        }),
        null !== e.$dots &&
          e.$dots
            .attr("role", "tablist")
            .find("li")
            .each(function (t) {
              i(this).attr({
                role: "presentation",
                "aria-selected": "false",
                "aria-controls": "navigation" + e.instanceUid + t,
                id: "slick-slide" + e.instanceUid + t,
              });
            })
            .first()
            .attr("aria-selected", "true")
            .end()
            .find("button")
            .attr("role", "button")
            .end()
            .closest("div")
            .attr("role", "toolbar"),
        e.activateADA();
    }),
    (e.prototype.initArrowEvents = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow
          .off("click.slick")
          .on("click.slick", { message: "previous" }, i.changeSlide),
        i.$nextArrow
          .off("click.slick")
          .on("click.slick", { message: "next" }, i.changeSlide));
    }),
    (e.prototype.initDotEvents = function () {
      var e = this;
      !0 === e.options.dots &&
        e.slideCount > e.options.slidesToShow &&
        i("li", e.$dots).on("click.slick", { message: "index" }, e.changeSlide),
        !0 === e.options.dots &&
          !0 === e.options.pauseOnDotsHover &&
          i("li", e.$dots)
            .on("mouseenter.slick", i.proxy(e.interrupt, e, !0))
            .on("mouseleave.slick", i.proxy(e.interrupt, e, !1));
    }),
    (e.prototype.initSlideEvents = function () {
      var e = this;
      e.options.pauseOnHover &&
        (e.$list.on("mouseenter.slick", i.proxy(e.interrupt, e, !0)),
        e.$list.on("mouseleave.slick", i.proxy(e.interrupt, e, !1)));
    }),
    (e.prototype.initializeEvents = function () {
      var e = this;
      e.initArrowEvents(),
        e.initDotEvents(),
        e.initSlideEvents(),
        e.$list.on(
          "touchstart.slick mousedown.slick",
          { action: "start" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchmove.slick mousemove.slick",
          { action: "move" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchend.slick mouseup.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on(
          "touchcancel.slick mouseleave.slick",
          { action: "end" },
          e.swipeHandler
        ),
        e.$list.on("click.slick", e.clickHandler),
        i(document).on(e.visibilityChange, i.proxy(e.visibility, e)),
        !0 === e.options.accessibility &&
          e.$list.on("keydown.slick", e.keyHandler),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        i(window).on(
          "orientationchange.slick.slick-" + e.instanceUid,
          i.proxy(e.orientationChange, e)
        ),
        i(window).on(
          "resize.slick.slick-" + e.instanceUid,
          i.proxy(e.resize, e)
        ),
        i("[draggable!=true]", e.$slideTrack).on("dragstart", e.preventDefault),
        i(window).on("load.slick.slick-" + e.instanceUid, e.setPosition),
        i(document).on("ready.slick.slick-" + e.instanceUid, e.setPosition);
    }),
    (e.prototype.initUI = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.show(), i.$nextArrow.show()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.show();
    }),
    (e.prototype.keyHandler = function (i) {
      var e = this;
      i.target.tagName.match("TEXTAREA|INPUT|SELECT") ||
        (37 === i.keyCode && !0 === e.options.accessibility
          ? e.changeSlide({
              data: { message: !0 === e.options.rtl ? "next" : "previous" },
            })
          : 39 === i.keyCode &&
            !0 === e.options.accessibility &&
            e.changeSlide({
              data: { message: !0 === e.options.rtl ? "previous" : "next" },
            }));
    }),
    (e.prototype.lazyLoad = function () {
      function e(e) {
        i("img[data-lazy]", e).each(function () {
          var e = i(this),
            t = i(this).attr("data-lazy"),
            o = document.createElement("img");
          (o.onload = function () {
            e.animate({ opacity: 0 }, 100, function () {
              e.attr("src", t).animate({ opacity: 1 }, 200, function () {
                e.removeAttr("data-lazy").removeClass("slick-loading");
              }),
                n.$slider.trigger("lazyLoaded", [n, e, t]);
            });
          }),
            (o.onerror = function () {
              e
                .removeAttr("data-lazy")
                .removeClass("slick-loading")
                .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, e, t]);
            }),
            (o.src = t);
        });
      }
      var t,
        o,
        s,
        n = this;
      !0 === n.options.centerMode
        ? !0 === n.options.infinite
          ? ((o = n.currentSlide + (n.options.slidesToShow / 2 + 1)),
            (s = o + n.options.slidesToShow + 2))
          : ((o = Math.max(
              0,
              n.currentSlide - (n.options.slidesToShow / 2 + 1)
            )),
            (s = n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide))
        : ((o = n.options.infinite
            ? n.options.slidesToShow + n.currentSlide
            : n.currentSlide),
          (s = Math.ceil(o + n.options.slidesToShow)),
          !0 === n.options.fade && (o > 0 && o--, s <= n.slideCount && s++)),
        e(n.$slider.find(".slick-slide").slice(o, s)),
        n.slideCount <= n.options.slidesToShow
          ? ((t = n.$slider.find(".slick-slide")), e(t))
          : n.currentSlide >= n.slideCount - n.options.slidesToShow
          ? ((t = n.$slider
              .find(".slick-cloned")
              .slice(0, n.options.slidesToShow)),
            e(t))
          : 0 === n.currentSlide &&
            ((t = n.$slider
              .find(".slick-cloned")
              .slice(-1 * n.options.slidesToShow)),
            e(t));
    }),
    (e.prototype.loadSlider = function () {
      var i = this;
      i.setPosition(),
        i.$slideTrack.css({ opacity: 1 }),
        i.$slider.removeClass("slick-loading"),
        i.initUI(),
        "progressive" === i.options.lazyLoad && i.progressiveLazyLoad();
    }),
    (e.prototype.next = e.prototype.slickNext = function () {
      this.changeSlide({ data: { message: "next" } });
    }),
    (e.prototype.orientationChange = function () {
      var i = this;
      i.checkResponsive(), i.setPosition();
    }),
    (e.prototype.pause = e.prototype.slickPause = function () {
      var i = this;
      i.autoPlayClear(), (i.paused = !0);
    }),
    (e.prototype.play = e.prototype.slickPlay = function () {
      var i = this;
      i.autoPlay(),
        (i.options.autoplay = !0),
        (i.paused = !1),
        (i.focussed = !1),
        (i.interrupted = !1);
    }),
    (e.prototype.postSlide = function (i) {
      var e = this;
      e.unslicked ||
        (e.$slider.trigger("afterChange", [e, i]),
        (e.animating = !1),
        e.setPosition(),
        (e.swipeLeft = null),
        e.options.autoplay && e.autoPlay(),
        !0 === e.options.accessibility && e.initADA());
    }),
    (e.prototype.prev = e.prototype.slickPrev = function () {
      this.changeSlide({ data: { message: "previous" } });
    }),
    (e.prototype.preventDefault = function (i) {
      i.preventDefault();
    }),
    (e.prototype.progressiveLazyLoad = function (e) {
      e = e || 1;
      var t,
        o,
        s,
        n = this,
        r = i("img[data-lazy]", n.$slider);
      r.length
        ? ((t = r.first()),
          (o = t.attr("data-lazy")),
          (s = document.createElement("img")),
          (s.onload = function () {
            t
              .attr("src", o)
              .removeAttr("data-lazy")
              .removeClass("slick-loading"),
              !0 === n.options.adaptiveHeight && n.setPosition(),
              n.$slider.trigger("lazyLoaded", [n, t, o]),
              n.progressiveLazyLoad();
          }),
          (s.onerror = function () {
            3 > e
              ? setTimeout(function () {
                  n.progressiveLazyLoad(e + 1);
                }, 500)
              : (t
                  .removeAttr("data-lazy")
                  .removeClass("slick-loading")
                  .addClass("slick-lazyload-error"),
                n.$slider.trigger("lazyLoadError", [n, t, o]),
                n.progressiveLazyLoad());
          }),
          (s.src = o))
        : n.$slider.trigger("allImagesLoaded", [n]);
    }),
    (e.prototype.refresh = function (e) {
      var t,
        o,
        s = this;
      (o = s.slideCount - s.options.slidesToShow),
        !s.options.infinite && s.currentSlide > o && (s.currentSlide = o),
        s.slideCount <= s.options.slidesToShow && (s.currentSlide = 0),
        (t = s.currentSlide),
        s.destroy(!0),
        i.extend(s, s.initials, { currentSlide: t }),
        s.init(),
        e || s.changeSlide({ data: { message: "index", index: t } }, !1);
    }),
    (e.prototype.registerBreakpoints = function () {
      var e,
        t,
        o,
        s = this,
        n = s.options.responsive || null;
      if ("array" === i.type(n) && n.length) {
        s.respondTo = s.options.respondTo || "window";
        for (e in n)
          if (
            ((o = s.breakpoints.length - 1),
            (t = n[e].breakpoint),
            n.hasOwnProperty(e))
          ) {
            for (; o >= 0; )
              s.breakpoints[o] &&
                s.breakpoints[o] === t &&
                s.breakpoints.splice(o, 1),
                o--;
            s.breakpoints.push(t), (s.breakpointSettings[t] = n[e].settings);
          }
        s.breakpoints.sort(function (i, e) {
          return s.options.mobileFirst ? i - e : e - i;
        });
      }
    }),
    (e.prototype.reinit = function () {
      var e = this;
      (e.$slides = e.$slideTrack
        .children(e.options.slide)
        .addClass("slick-slide")),
        (e.slideCount = e.$slides.length),
        e.currentSlide >= e.slideCount &&
          0 !== e.currentSlide &&
          (e.currentSlide = e.currentSlide - e.options.slidesToScroll),
        e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0),
        e.registerBreakpoints(),
        e.setProps(),
        e.setupInfinite(),
        e.buildArrows(),
        e.updateArrows(),
        e.initArrowEvents(),
        e.buildDots(),
        e.updateDots(),
        e.initDotEvents(),
        e.cleanUpSlideEvents(),
        e.initSlideEvents(),
        e.checkResponsive(!1, !0),
        !0 === e.options.focusOnSelect &&
          i(e.$slideTrack).children().on("click.slick", e.selectHandler),
        e.setSlideClasses(
          "number" == typeof e.currentSlide ? e.currentSlide : 0
        ),
        e.setPosition(),
        e.focusHandler(),
        (e.paused = !e.options.autoplay),
        e.autoPlay(),
        e.$slider.trigger("reInit", [e]);
    }),
    (e.prototype.resize = function () {
      var e = this;
      i(window).width() !== e.windowWidth &&
        (clearTimeout(e.windowDelay),
        (e.windowDelay = window.setTimeout(function () {
          (e.windowWidth = i(window).width()),
            e.checkResponsive(),
            e.unslicked || e.setPosition();
        }, 50)));
    }),
    (e.prototype.removeSlide = e.prototype.slickRemove = function (i, e, t) {
      var o = this;
      return (
        "boolean" == typeof i
          ? ((e = i), (i = !0 === e ? 0 : o.slideCount - 1))
          : (i = !0 === e ? --i : i),
        !(o.slideCount < 1 || 0 > i || i > o.slideCount - 1) &&
          (o.unload(),
          !0 === t
            ? o.$slideTrack.children().remove()
            : o.$slideTrack.children(this.options.slide).eq(i).remove(),
          (o.$slides = o.$slideTrack.children(this.options.slide)),
          o.$slideTrack.children(this.options.slide).detach(),
          o.$slideTrack.append(o.$slides),
          (o.$slidesCache = o.$slides),
          void o.reinit())
      );
    }),
    (e.prototype.setCSS = function (i) {
      var e,
        t,
        o = this,
        s = {};
      !0 === o.options.rtl && (i = -i),
        (e = "left" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (t = "top" == o.positionProp ? Math.ceil(i) + "px" : "0px"),
        (s[o.positionProp] = i),
        !1 === o.transformsEnabled
          ? o.$slideTrack.css(s)
          : ((s = {}),
            !1 === o.cssTransitions
              ? ((s[o.animType] = "translate(" + e + ", " + t + ")"),
                o.$slideTrack.css(s))
              : ((s[o.animType] = "translate3d(" + e + ", " + t + ", 0px)"),
                o.$slideTrack.css(s)));
    }),
    (e.prototype.setDimensions = function () {
      var i = this;
      !1 === i.options.vertical
        ? !0 === i.options.centerMode &&
          i.$list.css({ padding: "0px " + i.options.centerPadding })
        : (i.$list.height(
            i.$slides.first().outerHeight(!0) * i.options.slidesToShow
          ),
          !0 === i.options.centerMode &&
            i.$list.css({ padding: i.options.centerPadding + " 0px" })),
        (i.listWidth = i.$list.width()),
        (i.listHeight = i.$list.height()),
        !1 === i.options.vertical && !1 === i.options.variableWidth
          ? ((i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow)),
            i.$slideTrack.width(
              Math.ceil(
                i.slideWidth * i.$slideTrack.children(".slick-slide").length
              )
            ))
          : !0 === i.options.variableWidth
          ? i.$slideTrack.width(5e3 * i.slideCount)
          : ((i.slideWidth = Math.ceil(i.listWidth)),
            i.$slideTrack.height(
              Math.ceil(
                i.$slides.first().outerHeight(!0) *
                  i.$slideTrack.children(".slick-slide").length
              )
            ));
      var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
      !1 === i.options.variableWidth &&
        i.$slideTrack.children(".slick-slide").width(i.slideWidth - e);
    }),
    (e.prototype.setFade = function () {
      var e,
        t = this;
      t.$slides.each(function (o, s) {
        (e = t.slideWidth * o * -1),
          !0 === t.options.rtl
            ? i(s).css({
                position: "relative",
                right: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              })
            : i(s).css({
                position: "relative",
                left: e,
                top: 0,
                zIndex: t.options.zIndex - 2,
                opacity: 0,
              });
      }),
        t.$slides
          .eq(t.currentSlide)
          .css({ zIndex: t.options.zIndex - 1, opacity: 1 });
    }),
    (e.prototype.setHeight = function () {
      var i = this;
      if (
        1 === i.options.slidesToShow &&
        !0 === i.options.adaptiveHeight &&
        !1 === i.options.vertical
      ) {
        var e = i.$slides.eq(i.currentSlide).outerHeight(!0);
        i.$list.css("height", e);
      }
    }),
    (e.prototype.setOption = e.prototype.slickSetOption = function () {
      var e,
        t,
        o,
        s,
        n,
        r = this,
        l = !1;
      if (
        ("object" === i.type(arguments[0])
          ? ((o = arguments[0]), (l = arguments[1]), (n = "multiple"))
          : "string" === i.type(arguments[0]) &&
            ((o = arguments[0]),
            (s = arguments[1]),
            (l = arguments[2]),
            "responsive" === arguments[0] && "array" === i.type(arguments[1])
              ? (n = "responsive")
              : void 0 !== arguments[1] && (n = "single")),
        "single" === n)
      )
        r.options[o] = s;
      else if ("multiple" === n)
        i.each(o, function (i, e) {
          r.options[i] = e;
        });
      else if ("responsive" === n)
        for (t in s)
          if ("array" !== i.type(r.options.responsive))
            r.options.responsive = [s[t]];
          else {
            for (e = r.options.responsive.length - 1; e >= 0; )
              r.options.responsive[e].breakpoint === s[t].breakpoint &&
                r.options.responsive.splice(e, 1),
                e--;
            r.options.responsive.push(s[t]);
          }
      l && (r.unload(), r.reinit());
    }),
    (e.prototype.setPosition = function () {
      var i = this;
      i.setDimensions(),
        i.setHeight(),
        !1 === i.options.fade
          ? i.setCSS(i.getLeft(i.currentSlide))
          : i.setFade(),
        i.$slider.trigger("setPosition", [i]);
    }),
    (e.prototype.setProps = function () {
      var i = this,
        e = document.body.style;
      (i.positionProp = !0 === i.options.vertical ? "top" : "left"),
        "top" === i.positionProp
          ? i.$slider.addClass("slick-vertical")
          : i.$slider.removeClass("slick-vertical"),
        (void 0 !== e.WebkitTransition ||
          void 0 !== e.MozTransition ||
          void 0 !== e.msTransition) &&
          !0 === i.options.useCSS &&
          (i.cssTransitions = !0),
        i.options.fade &&
          ("number" == typeof i.options.zIndex
            ? i.options.zIndex < 3 && (i.options.zIndex = 3)
            : (i.options.zIndex = i.defaults.zIndex)),
        void 0 !== e.OTransform &&
          ((i.animType = "OTransform"),
          (i.transformType = "-o-transform"),
          (i.transitionType = "OTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.MozTransform &&
          ((i.animType = "MozTransform"),
          (i.transformType = "-moz-transform"),
          (i.transitionType = "MozTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.MozPerspective &&
            (i.animType = !1)),
        void 0 !== e.webkitTransform &&
          ((i.animType = "webkitTransform"),
          (i.transformType = "-webkit-transform"),
          (i.transitionType = "webkitTransition"),
          void 0 === e.perspectiveProperty &&
            void 0 === e.webkitPerspective &&
            (i.animType = !1)),
        void 0 !== e.msTransform &&
          ((i.animType = "msTransform"),
          (i.transformType = "-ms-transform"),
          (i.transitionType = "msTransition"),
          void 0 === e.msTransform && (i.animType = !1)),
        void 0 !== e.transform &&
          !1 !== i.animType &&
          ((i.animType = "transform"),
          (i.transformType = "transform"),
          (i.transitionType = "transition")),
        (i.transformsEnabled =
          i.options.useTransform && null !== i.animType && !1 !== i.animType);
    }),
    (e.prototype.setSlideClasses = function (i) {
      var e,
        t,
        o,
        s,
        n = this;
      (t = n.$slider
        .find(".slick-slide")
        .removeClass("slick-active slick-center slick-current")
        .attr("aria-hidden", "true")),
        n.$slides.eq(i).addClass("slick-current"),
        !0 === n.options.centerMode
          ? ((e = Math.floor(n.options.slidesToShow / 2)),
            !0 === n.options.infinite &&
              (i >= e && i <= n.slideCount - 1 - e
                ? n.$slides
                    .slice(i - e, i + e + 1)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")
                : ((o = n.options.slidesToShow + i),
                  t
                    .slice(o - e + 1, o + e + 2)
                    .addClass("slick-active")
                    .attr("aria-hidden", "false")),
              0 === i
                ? t
                    .eq(t.length - 1 - n.options.slidesToShow)
                    .addClass("slick-center")
                : i === n.slideCount - 1 &&
                  t.eq(n.options.slidesToShow).addClass("slick-center")),
            n.$slides.eq(i).addClass("slick-center"))
          : i >= 0 && i <= n.slideCount - n.options.slidesToShow
          ? n.$slides
              .slice(i, i + n.options.slidesToShow)
              .addClass("slick-active")
              .attr("aria-hidden", "false")
          : t.length <= n.options.slidesToShow
          ? t.addClass("slick-active").attr("aria-hidden", "false")
          : ((s = n.slideCount % n.options.slidesToShow),
            (o = !0 === n.options.infinite ? n.options.slidesToShow + i : i),
            n.options.slidesToShow == n.options.slidesToScroll &&
            n.slideCount - i < n.options.slidesToShow
              ? t
                  .slice(o - (n.options.slidesToShow - s), o + s)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")
              : t
                  .slice(o, o + n.options.slidesToShow)
                  .addClass("slick-active")
                  .attr("aria-hidden", "false")),
        "ondemand" === n.options.lazyLoad && n.lazyLoad();
    }),
    (e.prototype.setupInfinite = function () {
      var e,
        t,
        o,
        s = this;
      if (
        (!0 === s.options.fade && (s.options.centerMode = !1),
        !0 === s.options.infinite &&
          !1 === s.options.fade &&
          ((t = null), s.slideCount > s.options.slidesToShow))
      ) {
        for (
          o =
            !0 === s.options.centerMode
              ? s.options.slidesToShow + 1
              : s.options.slidesToShow,
            e = s.slideCount;
          e > s.slideCount - o;
          e -= 1
        )
          (t = e - 1),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t - s.slideCount)
              .prependTo(s.$slideTrack)
              .addClass("slick-cloned");
        for (e = 0; o > e; e += 1)
          (t = e),
            i(s.$slides[t])
              .clone(!0)
              .attr("id", "")
              .attr("data-slick-index", t + s.slideCount)
              .appendTo(s.$slideTrack)
              .addClass("slick-cloned");
        s.$slideTrack
          .find(".slick-cloned")
          .find("[id]")
          .each(function () {
            i(this).attr("id", "");
          });
      }
    }),
    (e.prototype.interrupt = function (i) {
      var e = this;
      i || e.autoPlay(), (e.interrupted = i);
    }),
    (e.prototype.selectHandler = function (e) {
      var t = this,
        o = i(e.target).is(".slick-slide")
          ? i(e.target)
          : i(e.target).parents(".slick-slide"),
        s = parseInt(o.attr("data-slick-index"));
      return (
        s || (s = 0),
        t.slideCount <= t.options.slidesToShow
          ? (t.setSlideClasses(s), void t.asNavFor(s))
          : void t.slideHandler(s)
      );
    }),
    (e.prototype.slideHandler = function (i, e, t) {
      var o,
        s,
        n,
        r,
        l,
        d = null,
        a = this;
      return (
        (e = e || !1),
        (!0 === a.animating && !0 === a.options.waitForAnimate) ||
        (!0 === a.options.fade && a.currentSlide === i) ||
        a.slideCount <= a.options.slidesToShow
          ? void 0
          : (!1 === e && a.asNavFor(i),
            (o = i),
            (d = a.getLeft(o)),
            (r = a.getLeft(a.currentSlide)),
            (a.currentLeft = null === a.swipeLeft ? r : a.swipeLeft),
            !1 === a.options.infinite &&
            !1 === a.options.centerMode &&
            (0 > i || i > a.getDotCount() * a.options.slidesToScroll)
              ? void (
                  !1 === a.options.fade &&
                  ((o = a.currentSlide),
                  !0 !== t
                    ? a.animateSlide(r, function () {
                        a.postSlide(o);
                      })
                    : a.postSlide(o))
                )
              : !1 === a.options.infinite &&
                !0 === a.options.centerMode &&
                (0 > i || i > a.slideCount - a.options.slidesToScroll)
              ? void (
                  !1 === a.options.fade &&
                  ((o = a.currentSlide),
                  !0 !== t
                    ? a.animateSlide(r, function () {
                        a.postSlide(o);
                      })
                    : a.postSlide(o))
                )
              : (a.options.autoplay && clearInterval(a.autoPlayTimer),
                (s =
                  0 > o
                    ? a.slideCount % a.options.slidesToScroll != 0
                      ? a.slideCount - (a.slideCount % a.options.slidesToScroll)
                      : a.slideCount + o
                    : o >= a.slideCount
                    ? a.slideCount % a.options.slidesToScroll != 0
                      ? 0
                      : o - a.slideCount
                    : o),
                (a.animating = !0),
                a.$slider.trigger("beforeChange", [a, a.currentSlide, s]),
                (n = a.currentSlide),
                (a.currentSlide = s),
                a.setSlideClasses(a.currentSlide),
                a.options.asNavFor &&
                  ((l = a.getNavTarget()),
                  (l = l.slick("getSlick")).slideCount <=
                    l.options.slidesToShow &&
                    l.setSlideClasses(a.currentSlide)),
                a.updateDots(),
                a.updateArrows(),
                !0 === a.options.fade
                  ? (!0 !== t
                      ? (a.fadeSlideOut(n),
                        a.fadeSlide(s, function () {
                          a.postSlide(s);
                        }))
                      : a.postSlide(s),
                    void a.animateHeight())
                  : void (!0 !== t
                      ? a.animateSlide(d, function () {
                          a.postSlide(s);
                        })
                      : a.postSlide(s))))
      );
    }),
    (e.prototype.startLoad = function () {
      var i = this;
      !0 === i.options.arrows &&
        i.slideCount > i.options.slidesToShow &&
        (i.$prevArrow.hide(), i.$nextArrow.hide()),
        !0 === i.options.dots &&
          i.slideCount > i.options.slidesToShow &&
          i.$dots.hide(),
        i.$slider.addClass("slick-loading");
    }),
    (e.prototype.swipeDirection = function () {
      var i,
        e,
        t,
        o,
        s = this;
      return (
        (i = s.touchObject.startX - s.touchObject.curX),
        (e = s.touchObject.startY - s.touchObject.curY),
        (t = Math.atan2(e, i)),
        0 > (o = Math.round((180 * t) / Math.PI)) && (o = 360 - Math.abs(o)),
        45 >= o && o >= 0
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : 360 >= o && o >= 315
          ? !1 === s.options.rtl
            ? "left"
            : "right"
          : o >= 135 && 225 >= o
          ? !1 === s.options.rtl
            ? "right"
            : "left"
          : !0 === s.options.verticalSwiping
          ? o >= 35 && 135 >= o
            ? "down"
            : "up"
          : "vertical"
      );
    }),
    (e.prototype.swipeEnd = function (i) {
      var e,
        t,
        o = this;
      if (
        ((o.dragging = !1),
        (o.interrupted = !1),
        (o.shouldClick = !(o.touchObject.swipeLength > 10)),
        void 0 === o.touchObject.curX)
      )
        return !1;
      if (
        (!0 === o.touchObject.edgeHit &&
          o.$slider.trigger("edge", [o, o.swipeDirection()]),
        o.touchObject.swipeLength >= o.touchObject.minSwipe)
      ) {
        switch ((t = o.swipeDirection())) {
          case "left":
          case "down":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide + o.getSlideCount())
              : o.currentSlide + o.getSlideCount()),
              (o.currentDirection = 0);
            break;
          case "right":
          case "up":
            (e = o.options.swipeToSlide
              ? o.checkNavigable(o.currentSlide - o.getSlideCount())
              : o.currentSlide - o.getSlideCount()),
              (o.currentDirection = 1);
        }
        "vertical" != t &&
          (o.slideHandler(e),
          (o.touchObject = {}),
          o.$slider.trigger("swipe", [o, t]));
      } else
        o.touchObject.startX !== o.touchObject.curX &&
          (o.slideHandler(o.currentSlide), (o.touchObject = {}));
    }),
    (e.prototype.swipeHandler = function (i) {
      var e = this;
      if (
        !(
          !1 === e.options.swipe ||
          ("ontouchend" in document && !1 === e.options.swipe) ||
          (!1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))
        )
      )
        switch (
          ((e.touchObject.fingerCount =
            i.originalEvent && void 0 !== i.originalEvent.touches
              ? i.originalEvent.touches.length
              : 1),
          (e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold),
          !0 === e.options.verticalSwiping &&
            (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold),
          i.data.action)
        ) {
          case "start":
            e.swipeStart(i);
            break;
          case "move":
            e.swipeMove(i);
            break;
          case "end":
            e.swipeEnd(i);
        }
    }),
    (e.prototype.swipeMove = function (i) {
      var e,
        t,
        o,
        s,
        n,
        r = this;
      return (
        (n = void 0 !== i.originalEvent ? i.originalEvent.touches : null),
        !(!r.dragging || (n && 1 !== n.length)) &&
          ((e = r.getLeft(r.currentSlide)),
          (r.touchObject.curX = void 0 !== n ? n[0].pageX : i.clientX),
          (r.touchObject.curY = void 0 !== n ? n[0].pageY : i.clientY),
          (r.touchObject.swipeLength = Math.round(
            Math.sqrt(Math.pow(r.touchObject.curX - r.touchObject.startX, 2))
          )),
          !0 === r.options.verticalSwiping &&
            (r.touchObject.swipeLength = Math.round(
              Math.sqrt(Math.pow(r.touchObject.curY - r.touchObject.startY, 2))
            )),
          (t = r.swipeDirection()),
          "vertical" !== t
            ? (void 0 !== i.originalEvent &&
                r.touchObject.swipeLength > 4 &&
                i.preventDefault(),
              (s =
                (!1 === r.options.rtl ? 1 : -1) *
                (r.touchObject.curX > r.touchObject.startX ? 1 : -1)),
              !0 === r.options.verticalSwiping &&
                (s = r.touchObject.curY > r.touchObject.startY ? 1 : -1),
              (o = r.touchObject.swipeLength),
              (r.touchObject.edgeHit = !1),
              !1 === r.options.infinite &&
                ((0 === r.currentSlide && "right" === t) ||
                  (r.currentSlide >= r.getDotCount() && "left" === t)) &&
                ((o = r.touchObject.swipeLength * r.options.edgeFriction),
                (r.touchObject.edgeHit = !0)),
              !1 === r.options.vertical
                ? (r.swipeLeft = e + o * s)
                : (r.swipeLeft = e + o * (r.$list.height() / r.listWidth) * s),
              !0 === r.options.verticalSwiping && (r.swipeLeft = e + o * s),
              !0 !== r.options.fade &&
                !1 !== r.options.touchMove &&
                (!0 === r.animating
                  ? ((r.swipeLeft = null), !1)
                  : void r.setCSS(r.swipeLeft)))
            : void 0)
      );
    }),
    (e.prototype.swipeStart = function (i) {
      var e,
        t = this;
      return (
        (t.interrupted = !0),
        1 !== t.touchObject.fingerCount ||
        t.slideCount <= t.options.slidesToShow
          ? ((t.touchObject = {}), !1)
          : (void 0 !== i.originalEvent &&
              void 0 !== i.originalEvent.touches &&
              (e = i.originalEvent.touches[0]),
            (t.touchObject.startX = t.touchObject.curX =
              void 0 !== e ? e.pageX : i.clientX),
            (t.touchObject.startY = t.touchObject.curY =
              void 0 !== e ? e.pageY : i.clientY),
            void (t.dragging = !0))
      );
    }),
    (e.prototype.unfilterSlides = e.prototype.slickUnfilter = function () {
      var i = this;
      null !== i.$slidesCache &&
        (i.unload(),
        i.$slideTrack.children(this.options.slide).detach(),
        i.$slidesCache.appendTo(i.$slideTrack),
        i.reinit());
    }),
    (e.prototype.unload = function () {
      var e = this;
      i(".slick-cloned", e.$slider).remove(),
        e.$dots && e.$dots.remove(),
        e.$prevArrow &&
          e.htmlExpr.test(e.options.prevArrow) &&
          e.$prevArrow.remove(),
        e.$nextArrow &&
          e.htmlExpr.test(e.options.nextArrow) &&
          e.$nextArrow.remove(),
        e.$slides
          .removeClass("slick-slide slick-active slick-visible slick-current")
          .attr("aria-hidden", "true")
          .css("width", "");
    }),
    (e.prototype.unslick = function (i) {
      var e = this;
      e.$slider.trigger("unslick", [e, i]), e.destroy();
    }),
    (e.prototype.updateArrows = function () {
      var i = this;
      Math.floor(i.options.slidesToShow / 2),
        !0 === i.options.arrows &&
          i.slideCount > i.options.slidesToShow &&
          !i.options.infinite &&
          (i.$prevArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          i.$nextArrow
            .removeClass("slick-disabled")
            .attr("aria-disabled", "false"),
          0 === i.currentSlide
            ? (i.$prevArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$nextArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - i.options.slidesToShow &&
              !1 === i.options.centerMode
            ? (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false"))
            : i.currentSlide >= i.slideCount - 1 &&
              !0 === i.options.centerMode &&
              (i.$nextArrow
                .addClass("slick-disabled")
                .attr("aria-disabled", "true"),
              i.$prevArrow
                .removeClass("slick-disabled")
                .attr("aria-disabled", "false")));
    }),
    (e.prototype.updateDots = function () {
      var i = this;
      null !== i.$dots &&
        (i.$dots
          .find("li")
          .removeClass("slick-active")
          .attr("aria-hidden", "true"),
        i.$dots
          .find("li")
          .eq(Math.floor(i.currentSlide / i.options.slidesToScroll))
          .addClass("slick-active")
          .attr("aria-hidden", "false"));
    }),
    (e.prototype.visibility = function () {
      var i = this;
      i.options.autoplay &&
        (document[i.hidden] ? (i.interrupted = !0) : (i.interrupted = !1));
    }),
    (i.fn.slick = function () {
      var i,
        t,
        o = this,
        s = arguments[0],
        n = Array.prototype.slice.call(arguments, 1),
        r = o.length;
      for (i = 0; r > i; i++)
        if (
          ("object" == typeof s || void 0 === s
            ? (o[i].slick = new e(o[i], s))
            : (t = o[i].slick[s].apply(o[i].slick, n)),
          void 0 !== t)
        )
          return t;
      return o;
    });
});
